export const lineData = [
  {
    x: 0.0,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.6666666667,
    line4: 25.0,
    line5: 24.9999999999,
    line6: 25.0,
    line_animate: 25.0,
  },
  {
    x: 0.005005005,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.6066066066,
    line4: 24.9199199199,
    line5: 24.9199199198,
    line6: 24.9111052486,
    line_animate: 24.9199199199,
  },
  {
    x: 0.01001001,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.5465465465,
    line4: 24.8398398398,
    line5: 24.8398398397,
    line6: 24.8222231572,
    line_animate: 24.8398398398,
  },
  {
    x: 0.015015015,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.4864864865,
    line4: 24.7597597598,
    line5: 24.7597597596,
    line6: 24.7333470759,
    line_animate: 24.7597597598,
  },
  {
    x: 0.02002002,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.4264264264,
    line4: 24.6796796797,
    line5: 24.6796796796,
    line6: 24.6444709946,
    line_animate: 24.6796796797,
  },
  {
    x: 0.025025025,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.3663663664,
    line4: 24.5995995996,
    line5: 24.5995995995,
    line6: 24.5555953827,
    line_animate: 24.5995995996,
  },
  {
    x: 0.03003003,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.3063063063,
    line4: 24.5195195195,
    line5: 24.5195195194,
    line6: 24.4667454833,
    line_animate: 24.5195195195,
  },
  {
    x: 0.035035035,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.2462462462,
    line4: 24.4394394394,
    line5: 24.4394394393,
    line6: 24.3779029998,
    line_animate: 24.4394394394,
  },
  {
    x: 0.04004004,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.1861861862,
    line4: 24.3593593594,
    line5: 24.3593593592,
    line6: 24.2890605163,
    line_animate: 24.3593593594,
  },
  {
    x: 0.045045045,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.1261261261,
    line4: 24.2792792793,
    line5: 24.2792792792,
    line6: 24.2002180328,
    line_animate: 24.2792792793,
  },
  {
    x: 0.0500500501,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.0660660661,
    line4: 24.1991991992,
    line5: 24.1991991991,
    line6: 24.1113755492,
    line_animate: 24.1991991992,
  },
  {
    x: 0.0550550551,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.006006006,
    line4: 24.1191191191,
    line5: 24.119119119,
    line6: 24.0225426444,
    line_animate: 24.1191191191,
  },
  {
    x: 0.0600600601,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.9459459459,
    line4: 24.039039039,
    line5: 24.0390390389,
    line6: 23.933722907,
    line_animate: 24.039039039,
  },
  {
    x: 0.0650650651,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.8858858859,
    line4: 23.958958959,
    line5: 23.9589589589,
    line6: 23.8449271895,
    line_animate: 23.958958959,
  },
  {
    x: 0.0700700701,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.8258258258,
    line4: 23.8788788789,
    line5: 23.8788788788,
    line6: 23.7561469854,
    line_animate: 23.8788788789,
  },
  {
    x: 0.0750750751,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.7657657658,
    line4: 23.7987987988,
    line5: 23.7987987987,
    line6: 23.6673840804,
    line_animate: 23.7987987988,
  },
  {
    x: 0.0800800801,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.7057057057,
    line4: 23.7187187187,
    line5: 23.7187187186,
    line6: 23.5786451466,
    line_animate: 23.7187187187,
  },
  {
    x: 0.0850850851,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.6456456456,
    line4: 23.6386386386,
    line5: 23.6386386385,
    line6: 23.4899433856,
    line_animate: 23.6386386386,
  },
  {
    x: 0.0900900901,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.5855855856,
    line4: 23.5585585586,
    line5: 23.5585585585,
    line6: 23.4012540951,
    line_animate: 23.5585585586,
  },
  {
    x: 0.0950950951,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.5255255255,
    line4: 23.4784784785,
    line5: 23.4784784784,
    line6: 23.3125881546,
    line_animate: 23.4784784785,
  },
  {
    x: 0.1001001001,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.4654654655,
    line4: 23.3983983984,
    line5: 23.3983983983,
    line6: 23.2239450054,
    line_animate: 23.3983983984,
  },
  {
    x: 0.1051051051,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.4054054054,
    line4: 23.3183183183,
    line5: 23.3183183182,
    line6: 23.1353418945,
    line_animate: 23.3183183183,
  },
  {
    x: 0.1101101101,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.3453453453,
    line4: 23.2382382382,
    line5: 23.2382382382,
    line6: 23.0467395574,
    line_animate: 23.2382382382,
  },
  {
    x: 0.1151151151,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.2852852853,
    line4: 23.1581581582,
    line5: 23.1581581581,
    line6: 22.9581792779,
    line_animate: 23.1581581582,
  },
  {
    x: 0.1201201201,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.2252252252,
    line4: 23.0780780781,
    line5: 23.078078078,
    line6: 22.8696813938,
    line_animate: 23.0780780781,
  },
  {
    x: 0.1251251251,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.1651651652,
    line4: 22.997997998,
    line5: 22.9979979979,
    line6: 22.7812117495,
    line_animate: 22.997997998,
  },
  {
    x: 0.1301301301,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.1051051051,
    line4: 22.9179179179,
    line5: 22.9179179178,
    line6: 22.6928142024,
    line_animate: 22.9179179179,
  },
  {
    x: 0.1351351351,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.045045045,
    line4: 22.8378378378,
    line5: 22.8378378378,
    line6: 22.6045248222,
    line_animate: 22.8378378378,
  },
  {
    x: 0.1401401401,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.984984985,
    line4: 22.7577577578,
    line5: 22.7577577577,
    line6: 22.5162393082,
    line_animate: 22.7577577578,
  },
  {
    x: 0.1451451451,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.9249249249,
    line4: 22.6776776777,
    line5: 22.6776776776,
    line6: 22.4279537943,
    line_animate: 22.6776776777,
  },
  {
    x: 0.1501501502,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.8648648649,
    line4: 22.5975975976,
    line5: 22.5975975975,
    line6: 22.3396986224,
    line_animate: 22.5975975976,
  },
  {
    x: 0.1551551552,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.8048048048,
    line4: 22.5175175175,
    line5: 22.5175175175,
    line6: 22.2514749013,
    line_animate: 22.5175175175,
  },
  {
    x: 0.1601601602,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.7447447447,
    line4: 22.4374374374,
    line5: 22.4374374374,
    line6: 22.1633109926,
    line_animate: 22.4374374374,
  },
  {
    x: 0.1651651652,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.6846846847,
    line4: 22.3573573574,
    line5: 22.3573573573,
    line6: 22.0751536017,
    line_animate: 22.3573573574,
  },
  {
    x: 0.1701701702,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.6246246246,
    line4: 22.2772772773,
    line5: 22.2772772772,
    line6: 21.9869962108,
    line_animate: 22.2772772773,
  },
  {
    x: 0.1751751752,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.5645645646,
    line4: 22.1971971972,
    line5: 22.1971971971,
    line6: 21.8988841999,
    line_animate: 22.1971971972,
  },
  {
    x: 0.1801801802,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.5045045045,
    line4: 22.1171171171,
    line5: 22.1171171171,
    line6: 21.8108220571,
    line_animate: 22.1171171171,
  },
  {
    x: 0.1851851852,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.4444444444,
    line4: 22.037037037,
    line5: 22.037037037,
    line6: 21.7228105873,
    line_animate: 22.037037037,
  },
  {
    x: 0.1901901902,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.3843843844,
    line4: 21.956956957,
    line5: 21.9569569569,
    line6: 21.6349012402,
    line_animate: 21.956956957,
  },
  {
    x: 0.1951951952,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.3243243243,
    line4: 21.8768768769,
    line5: 21.8768768768,
    line6: 21.5469918932,
    line_animate: 21.8768768769,
  },
  {
    x: 0.2002002002,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.2642642643,
    line4: 21.7967967968,
    line5: 21.7967967967,
    line6: 21.4591219185,
    line_animate: 21.7967967968,
  },
  {
    x: 0.2052052052,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.2042042042,
    line4: 21.7167167167,
    line5: 21.7167167167,
    line6: 21.3713723014,
    line_animate: 21.7167167167,
  },
  {
    x: 0.2102102102,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.1441441441,
    line4: 21.6366366366,
    line5: 21.6366366366,
    line6: 21.2837179206,
    line_animate: 21.6366366366,
  },
  {
    x: 0.2152152152,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.0840840841,
    line4: 21.5565565566,
    line5: 21.5565565565,
    line6: 21.1960850535,
    line_animate: 21.5565565566,
  },
  {
    x: 0.2202202202,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.024024024,
    line4: 21.4764764765,
    line5: 21.4764764764,
    line6: 21.1084521864,
    line_animate: 21.4764764765,
  },
  {
    x: 0.2252252252,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.963963964,
    line4: 21.3963963964,
    line5: 21.3963963964,
    line6: 21.0208193193,
    line_animate: 21.3963963964,
  },
  {
    x: 0.2302302302,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.9039039039,
    line4: 21.3163163163,
    line5: 21.3163163163,
    line6: 20.933197812,
    line_animate: 21.3163163163,
  },
  {
    x: 0.2352352352,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.8438438438,
    line4: 21.2362362362,
    line5: 21.2362362362,
    line6: 20.8457025505,
    line_animate: 21.2362362362,
  },
  {
    x: 0.2402402402,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.7837837838,
    line4: 21.1561561562,
    line5: 21.1561561561,
    line6: 20.7582576245,
    line_animate: 21.1561561562,
  },
  {
    x: 0.2452452452,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.7237237237,
    line4: 21.0760760761,
    line5: 21.076076076,
    line6: 20.6708362286,
    line_animate: 21.0760760761,
  },
  {
    x: 0.2502502503,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.6636636637,
    line4: 20.995995996,
    line5: 20.995995996,
    line6: 20.5835365835,
    line_animate: 20.995995996,
  },
  {
    x: 0.2552552553,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.6036036036,
    line4: 20.9159159159,
    line5: 20.9159159159,
    line6: 20.496356308,
    line_animate: 20.9159159159,
  },
  {
    x: 0.2602602603,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.5435435435,
    line4: 20.8358358358,
    line5: 20.8358358358,
    line6: 20.4091778418,
    line_animate: 20.8358358358,
  },
  {
    x: 0.2652652653,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.4834834835,
    line4: 20.7557557558,
    line5: 20.7557557557,
    line6: 20.322066985,
    line_animate: 20.7557557558,
  },
  {
    x: 0.2702702703,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.4234234234,
    line4: 20.6756756757,
    line5: 20.6756756757,
    line6: 20.234958478,
    line_animate: 20.6756756757,
  },
  {
    x: 0.2752752753,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.3633633634,
    line4: 20.5955955956,
    line5: 20.5955955956,
    line6: 20.1478499711,
    line_animate: 20.5955955956,
  },
  {
    x: 0.2802802803,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.3033033033,
    line4: 20.5155155155,
    line5: 20.5155155155,
    line6: 20.0608656326,
    line_animate: 20.5155155155,
  },
  {
    x: 0.2852852853,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.2432432432,
    line4: 20.4354354354,
    line5: 20.4354354354,
    line6: 19.9741639948,
    line_animate: 20.4354354354,
  },
  {
    x: 0.2902902903,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.1831831832,
    line4: 20.3553553554,
    line5: 20.3553553553,
    line6: 19.8875777854,
    line_animate: 20.3553553554,
  },
  {
    x: 0.2952952953,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.1231231231,
    line4: 20.2752752753,
    line5: 20.2752752753,
    line6: 19.8010195962,
    line_animate: 20.2752752753,
  },
  {
    x: 0.3003003003,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.0630630631,
    line4: 20.1951951952,
    line5: 20.1951951952,
    line6: 19.7145340094,
    line_animate: 20.1951951952,
  },
  {
    x: 0.3053053053,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.003003003,
    line4: 20.1151151151,
    line5: 20.1151151151,
    line6: 19.6281547514,
    line_animate: 20.1151151151,
  },
  {
    x: 0.3103103103,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.9429429429,
    line4: 20.035035035,
    line5: 20.035035035,
    line6: 19.5418090744,
    line_animate: 20.035035035,
  },
  {
    x: 0.3153153153,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.8828828829,
    line4: 19.954954955,
    line5: 19.9549549549,
    line6: 19.4555450956,
    line_animate: 19.954954955,
  },
  {
    x: 0.3203203203,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.8228228228,
    line4: 19.8748748749,
    line5: 19.8748748749,
    line6: 19.3693757398,
    line_animate: 19.8748748749,
  },
  {
    x: 0.3253253253,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.7627627628,
    line4: 19.7947947948,
    line5: 19.7947947948,
    line6: 19.2832942011,
    line_animate: 19.7947947948,
  },
  {
    x: 0.3303303303,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.7027027027,
    line4: 19.7147147147,
    line5: 19.7147147147,
    line6: 19.1974010661,
    line_animate: 19.7147147147,
  },
  {
    x: 0.3353353353,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.6426426426,
    line4: 19.6346346346,
    line5: 19.6346346346,
    line6: 19.1115729965,
    line_animate: 19.6346346346,
  },
  {
    x: 0.3403403403,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.5825825826,
    line4: 19.5545545546,
    line5: 19.5545545546,
    line6: 19.0258557133,
    line_animate: 19.5545545546,
  },
  {
    x: 0.3453453453,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.5225225225,
    line4: 19.4744744745,
    line5: 19.4744744745,
    line6: 18.9401986026,
    line_animate: 19.4744744745,
  },
  {
    x: 0.3503503504,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.4624624625,
    line4: 19.3943943944,
    line5: 19.3943943944,
    line6: 18.8545993395,
    line_animate: 19.3943943944,
  },
  {
    x: 0.3553553554,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.4024024024,
    line4: 19.3143143143,
    line5: 19.3143143143,
    line6: 18.7691986675,
    line_animate: 19.3143143143,
  },
  {
    x: 0.3603603604,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.3423423423,
    line4: 19.2342342342,
    line5: 19.2342342342,
    line6: 18.6838185481,
    line_animate: 19.2342342342,
  },
  {
    x: 0.3653653654,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.2822822823,
    line4: 19.1541541542,
    line5: 19.1541541542,
    line6: 18.5985123133,
    line_animate: 19.1541541542,
  },
  {
    x: 0.3703703704,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.2222222222,
    line4: 19.0740740741,
    line5: 19.0740740741,
    line6: 18.5132274866,
    line_animate: 19.0740740741,
  },
  {
    x: 0.3753753754,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.1621621622,
    line4: 18.993993994,
    line5: 18.993993994,
    line6: 18.42794266,
    line_animate: 18.993993994,
  },
  {
    x: 0.3803803804,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.1021021021,
    line4: 18.9139139139,
    line5: 18.9139139139,
    line6: 18.3426578333,
    line_animate: 18.9139139139,
  },
  {
    x: 0.3853853854,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.042042042,
    line4: 18.8338338338,
    line5: 18.8338338339,
    line6: 18.2574238652,
    line_animate: 18.8338338338,
  },
  {
    x: 0.3903903904,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.981981982,
    line4: 18.7537537538,
    line5: 18.7537537538,
    line6: 18.1723409737,
    line_animate: 18.7537537538,
  },
  {
    x: 0.3953953954,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.9219219219,
    line4: 18.6736736737,
    line5: 18.6736736737,
    line6: 18.0873610458,
    line_animate: 18.6736736737,
  },
  {
    x: 0.4004004004,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.8618618619,
    line4: 18.5935935936,
    line5: 18.5935935936,
    line6: 18.0025494793,
    line_animate: 18.5935935936,
  },
  {
    x: 0.4054054054,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.8018018018,
    line4: 18.5135135135,
    line5: 18.5135135135,
    line6: 17.9177771817,
    line_animate: 18.5135135135,
  },
  {
    x: 0.4104104104,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.7417417417,
    line4: 18.4334334334,
    line5: 18.4334334335,
    line6: 17.8330836506,
    line_animate: 18.4334334334,
  },
  {
    x: 0.4154154154,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.6816816817,
    line4: 18.3533533534,
    line5: 18.3533533534,
    line6: 17.7486845394,
    line_animate: 18.3533533534,
  },
  {
    x: 0.4204204204,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.6216216216,
    line4: 18.2732732733,
    line5: 18.2732732733,
    line6: 17.6643422058,
    line_animate: 18.2732732733,
  },
  {
    x: 0.4254254254,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.5615615616,
    line4: 18.1931931932,
    line5: 18.1931931932,
    line6: 17.5800159482,
    line_animate: 18.1931931932,
  },
  {
    x: 0.4304304304,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.5015015015,
    line4: 18.1131131131,
    line5: 18.1131131132,
    line6: 17.4958585728,
    line_animate: 18.1131131131,
  },
  {
    x: 0.4354354354,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.4414414414,
    line4: 18.033033033,
    line5: 18.0330330331,
    line6: 17.4118284385,
    line_animate: 18.033033033,
  },
  {
    x: 0.4404404404,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.3813813814,
    line4: 17.952952953,
    line5: 17.952952953,
    line6: 17.3278218309,
    line_animate: 17.952952953,
  },
  {
    x: 0.4454454454,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.3213213213,
    line4: 17.8728728729,
    line5: 17.8728728729,
    line6: 17.2438152233,
    line_animate: 17.8728728729,
  },
  {
    x: 0.4504504505,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.2612612613,
    line4: 17.7927927928,
    line5: 17.7927927928,
    line6: 17.1598086157,
    line_animate: 17.7927927928,
  },
  {
    x: 0.4554554555,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.2012012012,
    line4: 17.7127127127,
    line5: 17.7127127128,
    line6: 17.075913375,
    line_animate: 17.7127127127,
  },
  {
    x: 0.4604604605,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.1411411411,
    line4: 17.6326326326,
    line5: 17.6326326327,
    line6: 16.9920565596,
    line_animate: 17.6326326326,
  },
  {
    x: 0.4654654655,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.0810810811,
    line4: 17.5525525526,
    line5: 17.5525525526,
    line6: 16.9082873824,
    line_animate: 17.5525525526,
  },
  {
    x: 0.4704704705,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.021021021,
    line4: 17.4724724725,
    line5: 17.4724724725,
    line6: 16.8245182052,
    line_animate: 17.4724724725,
  },
  {
    x: 0.4754754755,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.960960961,
    line4: 17.3923923924,
    line5: 17.3923923924,
    line6: 16.7407985924,
    line_animate: 17.3923923924,
  },
  {
    x: 0.4804804805,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.9009009009,
    line4: 17.3123123123,
    line5: 17.3123123124,
    line6: 16.6572766486,
    line_animate: 17.3123123123,
  },
  {
    x: 0.4854854855,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.8408408408,
    line4: 17.2322322322,
    line5: 17.2322322323,
    line6: 16.5738377569,
    line_animate: 17.2322322322,
  },
  {
    x: 0.4904904905,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.7807807808,
    line4: 17.1521521522,
    line5: 17.1521521522,
    line6: 16.4905394551,
    line_animate: 17.1521521522,
  },
  {
    x: 0.4954954955,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.7207207207,
    line4: 17.0720720721,
    line5: 17.0720720721,
    line6: 16.4072697203,
    line_animate: 17.0720720721,
  },
  {
    x: 0.5005005005,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.6606606607,
    line4: 16.991991992,
    line5: 16.9919919921,
    line6: 16.3240806587,
    line_animate: 16.991991992,
  },
  {
    x: 0.5055055055,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.6006006006,
    line4: 16.9119119119,
    line5: 16.911911912,
    line6: 16.2409872525,
    line_animate: 16.9119119119,
  },
  {
    x: 0.5105105105,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.5405405405,
    line4: 16.8318318318,
    line5: 16.8318318319,
    line6: 16.158064971,
    line_animate: 16.8318318318,
  },
  {
    x: 0.5155155155,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.4804804805,
    line4: 16.7517517518,
    line5: 16.7517517518,
    line6: 16.0751873646,
    line_animate: 16.7517517518,
  },
  {
    x: 0.5205205205,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.4204204204,
    line4: 16.6716716717,
    line5: 16.6716716717,
    line6: 15.9923661836,
    line_animate: 16.6716716717,
  },
  {
    x: 0.5255255255,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.3603603604,
    line4: 16.5915915916,
    line5: 16.5915915917,
    line6: 15.9096852397,
    line_animate: 16.5915915916,
  },
  {
    x: 0.5305305305,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.3003003003,
    line4: 16.5115115115,
    line5: 16.5115115116,
    line6: 15.8270781108,
    line_animate: 16.5115115115,
  },
  {
    x: 0.5355355355,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.2402402402,
    line4: 16.4314314314,
    line5: 16.4314314315,
    line6: 15.7446277782,
    line_animate: 16.4314314314,
  },
  {
    x: 0.5405405405,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.1801801802,
    line4: 16.3513513514,
    line5: 16.3513513514,
    line6: 15.6623978778,
    line_animate: 16.3513513514,
  },
  {
    x: 0.5455455455,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.1201201201,
    line4: 16.2712712713,
    line5: 16.2712712714,
    line6: 15.580238684,
    line_animate: 16.2712712713,
  },
  {
    x: 0.5505505506,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.0600600601,
    line4: 16.1911911912,
    line5: 16.1911911913,
    line6: 15.4981884005,
    line_animate: 16.1911911912,
  },
  {
    x: 0.5555555556,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.0,
    line4: 16.1111111111,
    line5: 16.1111111112,
    line6: 15.4162798034,
    line_animate: 16.1111111111,
  },
  {
    x: 0.5605605606,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.9399399399,
    line4: 16.031031031,
    line5: 16.0310310311,
    line6: 15.3344682508,
    line_animate: 16.031031031,
  },
  {
    x: 0.5655655656,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.8798798799,
    line4: 15.950950951,
    line5: 15.950950951,
    line6: 15.2529618088,
    line_animate: 15.950950951,
  },
  {
    x: 0.5705705706,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.8198198198,
    line4: 15.8708708709,
    line5: 15.870870871,
    line6: 15.1718804683,
    line_animate: 15.8708708709,
  },
  {
    x: 0.5755755756,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.7597597598,
    line4: 15.7907907908,
    line5: 15.7907907909,
    line6: 15.0914262792,
    line_animate: 15.7907907908,
  },
  {
    x: 0.5805805806,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.6996996997,
    line4: 15.7107107107,
    line5: 15.7107107108,
    line6: 15.0110386588,
    line_animate: 15.7107107107,
  },
  {
    x: 0.5855855856,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.6396396396,
    line4: 15.6306306306,
    line5: 15.6306306307,
    line6: 14.9308812399,
    line_animate: 15.6306306306,
  },
  {
    x: 0.5905905906,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.5795795796,
    line4: 15.5505505506,
    line5: 15.5505505507,
    line6: 14.850741594,
    line_animate: 15.5505505506,
  },
  {
    x: 0.5955955956,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.5195195195,
    line4: 15.4704704705,
    line5: 15.4704704706,
    line6: 14.7707526008,
    line_animate: 15.4704704705,
  },
  {
    x: 0.6006006006,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.4594594595,
    line4: 15.3903903904,
    line5: 15.3903903905,
    line6: 14.6907636076,
    line_animate: 15.3903903904,
  },
  {
    x: 0.6056056056,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.3993993994,
    line4: 15.3103103103,
    line5: 15.3103103104,
    line6: 14.6109105703,
    line_animate: 15.3103103103,
  },
  {
    x: 0.6106106106,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.3393393393,
    line4: 15.2302302302,
    line5: 15.2302302303,
    line6: 14.5311364369,
    line_animate: 15.2302302302,
  },
  {
    x: 0.6156156156,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.2792792793,
    line4: 15.1501501502,
    line5: 15.1501501503,
    line6: 14.4515687421,
    line_animate: 15.1501501502,
  },
  {
    x: 0.6206206206,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.2192192192,
    line4: 15.0700700701,
    line5: 15.0700700702,
    line6: 14.3723144585,
    line_animate: 15.0700700701,
  },
  {
    x: 0.6256256256,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.1591591592,
    line4: 14.98998999,
    line5: 14.9899899901,
    line6: 14.293114698,
    line_animate: 14.98998999,
  },
  {
    x: 0.6306306306,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.0990990991,
    line4: 14.9099099099,
    line5: 14.90990991,
    line6: 14.2140299972,
    line_animate: 14.9099099099,
  },
  {
    x: 0.6356356356,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.039039039,
    line4: 14.8298298298,
    line5: 14.8298298299,
    line6: 14.1353078326,
    line_animate: 14.8298298298,
  },
  {
    x: 0.6406406406,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.978978979,
    line4: 14.7497497497,
    line5: 14.7497497499,
    line6: 14.0569235906,
    line_animate: 14.7497497498,
  },
  {
    x: 0.6456456456,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.9189189189,
    line4: 14.6696696697,
    line5: 14.6696696698,
    line6: 13.9785917676,
    line_animate: 14.6696696697,
  },
  {
    x: 0.6506506507,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.8588588589,
    line4: 14.5895895896,
    line5: 14.5895895897,
    line6: 13.9004860137,
    line_animate: 14.5895895896,
  },
  {
    x: 0.6556556557,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.7987987988,
    line4: 14.5095095095,
    line5: 14.5095095096,
    line6: 13.8225209163,
    line_animate: 14.5095095095,
  },
  {
    x: 0.6606606607,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.7387387387,
    line4: 14.4294294294,
    line5: 14.4294294296,
    line6: 13.7446381407,
    line_animate: 14.4294294294,
  },
  {
    x: 0.6656656657,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.6786786787,
    line4: 14.3493493493,
    line5: 14.3493493495,
    line6: 13.6671209644,
    line_animate: 14.3493493494,
  },
  {
    x: 0.6706706707,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.6186186186,
    line4: 14.2692692693,
    line5: 14.2692692694,
    line6: 13.5898800094,
    line_animate: 14.2692692693,
  },
  {
    x: 0.6756756757,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.5585585586,
    line4: 14.1891891892,
    line5: 14.1891891893,
    line6: 13.5126834021,
    line_animate: 14.1891891892,
  },
  {
    x: 0.6806806807,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.4984984985,
    line4: 14.1091091091,
    line5: 14.1091091092,
    line6: 13.4358493937,
    line_animate: 14.1091091091,
  },
  {
    x: 0.6856856857,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.4384384384,
    line4: 14.029029029,
    line5: 14.0290290292,
    line6: 13.3594108809,
    line_animate: 14.029029029,
  },
  {
    x: 0.6906906907,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.3783783784,
    line4: 13.9489489489,
    line5: 13.9489489491,
    line6: 13.2830947546,
    line_animate: 13.9489489489,
  },
  {
    x: 0.6956956957,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.3183183183,
    line4: 13.8688688689,
    line5: 13.868868869,
    line6: 13.2070499014,
    line_animate: 13.8688688689,
  },
  {
    x: 0.7007007007,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.2582582583,
    line4: 13.7887887888,
    line5: 13.7887887889,
    line6: 13.1312028822,
    line_animate: 13.7887887888,
  },
  {
    x: 0.7057057057,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.1981981982,
    line4: 13.7087087087,
    line5: 13.7087087089,
    line6: 13.0555109196,
    line_animate: 13.7087087087,
  },
  {
    x: 0.7107107107,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.1381381381,
    line4: 13.6286286286,
    line5: 13.6286286288,
    line6: 12.9800722187,
    line_animate: 13.6286286286,
  },
  {
    x: 0.7157157157,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.0780780781,
    line4: 13.5485485485,
    line5: 13.5485485487,
    line6: 12.9046461605,
    line_animate: 13.5485485485,
  },
  {
    x: 0.7207207207,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.018018018,
    line4: 13.4684684685,
    line5: 13.4684684686,
    line6: 12.8292201023,
    line_animate: 13.4684684685,
  },
  {
    x: 0.7257257257,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.957957958,
    line4: 13.3883883884,
    line5: 13.3883883885,
    line6: 12.75389737,
    line_animate: 13.3883883884,
  },
  {
    x: 0.7307307307,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.8978978979,
    line4: 13.3083083083,
    line5: 13.3083083085,
    line6: 12.6786572174,
    line_animate: 13.3083083083,
  },
  {
    x: 0.7357357357,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.8378378378,
    line4: 13.2282282282,
    line5: 13.2282282284,
    line6: 12.6034329382,
    line_animate: 13.2282282282,
  },
  {
    x: 0.7407407407,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.7777777778,
    line4: 13.1481481481,
    line5: 13.1481481483,
    line6: 12.5284320112,
    line_animate: 13.1481481481,
  },
  {
    x: 0.7457457457,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.7177177177,
    line4: 13.0680680681,
    line5: 13.0680680682,
    line6: 12.4537150124,
    line_animate: 13.0680680681,
  },
  {
    x: 0.7507507508,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.6576576577,
    line4: 12.987987988,
    line5: 12.9879879881,
    line6: 12.3792361974,
    line_animate: 12.987987988,
  },
  {
    x: 0.7557557558,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.5975975976,
    line4: 12.9079079079,
    line5: 12.9079079081,
    line6: 12.3047573824,
    line_animate: 12.9079079079,
  },
  {
    x: 0.7607607608,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.5375375375,
    line4: 12.8278278278,
    line5: 12.827827828,
    line6: 12.2304383122,
    line_animate: 12.8278278278,
  },
  {
    x: 0.7657657658,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.4774774775,
    line4: 12.7477477477,
    line5: 12.7477477479,
    line6: 12.1562661816,
    line_animate: 12.7477477477,
  },
  {
    x: 0.7707707708,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.4174174174,
    line4: 12.6676676677,
    line5: 12.6676676678,
    line6: 12.0821776423,
    line_animate: 12.6676676677,
  },
  {
    x: 0.7757757758,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.3573573574,
    line4: 12.5875875876,
    line5: 12.5875875878,
    line6: 12.0082329732,
    line_animate: 12.5875875876,
  },
  {
    x: 0.7807807808,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.2972972973,
    line4: 12.5075075075,
    line5: 12.5075075077,
    line6: 11.9344902808,
    line_animate: 12.5075075075,
  },
  {
    x: 0.7857857858,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.2372372372,
    line4: 12.4274274274,
    line5: 12.4274274276,
    line6: 11.8609147826,
    line_animate: 12.4274274274,
  },
  {
    x: 0.7907907908,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.1771771772,
    line4: 12.3473473473,
    line5: 12.3473473475,
    line6: 11.7876718044,
    line_animate: 12.3473473473,
  },
  {
    x: 0.7957957958,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.1171171171,
    line4: 12.2672672673,
    line5: 12.2672672674,
    line6: 11.714702015,
    line_animate: 12.2672672673,
  },
  {
    x: 0.8008008008,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.0570570571,
    line4: 12.1871871872,
    line5: 12.1871871874,
    line6: 11.6421630457,
    line_animate: 12.1871871872,
  },
  {
    x: 0.8058058058,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.996996997,
    line4: 12.1071071071,
    line5: 12.1071071073,
    line6: 11.5703059233,
    line_animate: 12.1071071071,
  },
  {
    x: 0.8108108108,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.9369369369,
    line4: 12.027027027,
    line5: 12.0270270272,
    line6: 11.4984708654,
    line_animate: 12.027027027,
  },
  {
    x: 0.8158158158,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.8768768769,
    line4: 11.9469469469,
    line5: 11.9469469471,
    line6: 11.4268215424,
    line_animate: 11.9469469469,
  },
  {
    x: 0.8208208208,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.8168168168,
    line4: 11.8668668669,
    line5: 11.8668668671,
    line6: 11.3553750533,
    line_animate: 11.8668668669,
  },
  {
    x: 0.8258258258,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.7567567568,
    line4: 11.7867867868,
    line5: 11.786786787,
    line6: 11.2839745056,
    line_animate: 11.7867867868,
  },
  {
    x: 0.8308308308,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.6966966967,
    line4: 11.7067067067,
    line5: 11.7067067069,
    line6: 11.2129584247,
    line_animate: 11.7067067067,
  },
  {
    x: 0.8358358358,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.6366366366,
    line4: 11.6266266266,
    line5: 11.6266266268,
    line6: 11.142154436,
    line_animate: 11.6266266266,
  },
  {
    x: 0.8408408408,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.5765765766,
    line4: 11.5465465465,
    line5: 11.5465465467,
    line6: 11.071843526,
    line_animate: 11.5465465465,
  },
  {
    x: 0.8458458458,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.5165165165,
    line4: 11.4664664665,
    line5: 11.4664664667,
    line6: 11.0023462794,
    line_animate: 11.4664664665,
  },
  {
    x: 0.8508508509,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.4564564565,
    line4: 11.3863863864,
    line5: 11.3863863866,
    line6: 10.9335070545,
    line_animate: 11.3863863864,
  },
  {
    x: 0.8558558559,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.3963963964,
    line4: 11.3063063063,
    line5: 11.3063063065,
    line6: 10.8651334637,
    line_animate: 11.3063063063,
  },
  {
    x: 0.8608608609,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.3363363363,
    line4: 11.2262262262,
    line5: 11.2262262264,
    line6: 10.7970246379,
    line_animate: 11.2262262262,
  },
  {
    x: 0.8658658659,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.2762762763,
    line4: 11.1461461461,
    line5: 11.1461461464,
    line6: 10.7290352027,
    line_animate: 11.1461461461,
  },
  {
    x: 0.8708708709,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.2162162162,
    line4: 11.0660660661,
    line5: 11.0660660663,
    line6: 10.6610993665,
    line_animate: 11.0660660661,
  },
  {
    x: 0.8758758759,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.1561561562,
    line4: 10.985985986,
    line5: 10.9859859862,
    line6: 10.5935997402,
    line_animate: 10.985985986,
  },
  {
    x: 0.8808808809,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.0960960961,
    line4: 10.9059059059,
    line5: 10.9059059061,
    line6: 10.5269150494,
    line_animate: 10.9059059059,
  },
  {
    x: 0.8858858859,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.036036036,
    line4: 10.8258258258,
    line5: 10.825825826,
    line6: 10.4602682302,
    line_animate: 10.8258258258,
  },
  {
    x: 0.8908908909,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.975975976,
    line4: 10.7457457457,
    line5: 10.745745746,
    line6: 10.393801962,
    line_animate: 10.7457457457,
  },
  {
    x: 0.8958958959,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.9159159159,
    line4: 10.6656656657,
    line5: 10.6656656659,
    line6: 10.3275610999,
    line_animate: 10.6656656657,
  },
  {
    x: 0.9009009009,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.8558558559,
    line4: 10.5855855856,
    line5: 10.5855855858,
    line6: 10.2615988332,
    line_animate: 10.5855855856,
  },
  {
    x: 0.9059059059,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.7957957958,
    line4: 10.5055055055,
    line5: 10.5055055057,
    line6: 10.1956365666,
    line_animate: 10.5055055055,
  },
  {
    x: 0.9109109109,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.7357357357,
    line4: 10.4254254254,
    line5: 10.4254254257,
    line6: 10.1296742999,
    line_animate: 10.4254254254,
  },
  {
    x: 0.9159159159,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.6756756757,
    line4: 10.3453453453,
    line5: 10.3453453456,
    line6: 10.063743596,
    line_animate: 10.3453453453,
  },
  {
    x: 0.9209209209,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.6156156156,
    line4: 10.2652652653,
    line5: 10.2652652655,
    line6: 9.9983985151,
    line_animate: 10.2652652653,
  },
  {
    x: 0.9259259259,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.5555555556,
    line4: 10.1851851852,
    line5: 10.1851851854,
    line6: 9.9336339234,
    line_animate: 10.1851851852,
  },
  {
    x: 0.9309309309,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.4954954955,
    line4: 10.1051051051,
    line5: 10.1051051053,
    line6: 9.869082532,
    line_animate: 10.1051051051,
  },
  {
    x: 0.9359359359,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.4354354354,
    line4: 10.025025025,
    line5: 10.0250250253,
    line6: 9.8047214748,
    line_animate: 10.025025025,
  },
  {
    x: 0.9409409409,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.3753753754,
    line4: 9.9449449449,
    line5: 9.9449449452,
    line6: 9.7404227379,
    line_animate: 9.9449449449,
  },
  {
    x: 0.9459459459,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.3153153153,
    line4: 9.8648648649,
    line5: 9.8648648651,
    line6: 9.6763501238,
    line_animate: 9.8648648649,
  },
  {
    x: 0.950950951,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.2552552553,
    line4: 9.7847847848,
    line5: 9.784784785,
    line6: 9.6127081472,
    line_animate: 9.7847847848,
  },
  {
    x: 0.955955956,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.1951951952,
    line4: 9.7047047047,
    line5: 9.7047047049,
    line6: 9.5493406436,
    line_animate: 9.7047047047,
  },
  {
    x: 0.960960961,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.1351351351,
    line4: 9.6246246246,
    line5: 9.6246246249,
    line6: 9.4859951011,
    line_animate: 9.6246246246,
  },
  {
    x: 0.965965966,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.0750750751,
    line4: 9.5445445445,
    line5: 9.5445445448,
    line6: 9.4227421618,
    line_animate: 9.5445445445,
  },
  {
    x: 0.970970971,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.015015015,
    line4: 9.4644644645,
    line5: 9.4644644647,
    line6: 9.3596429756,
    line_animate: 9.4644644645,
  },
  {
    x: 0.975975976,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.954954955,
    line4: 9.3843843844,
    line5: 9.3843843846,
    line6: 9.2968844234,
    line_animate: 9.3843843844,
  },
  {
    x: 0.980980981,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.8948948949,
    line4: 9.3043043043,
    line5: 9.3043043046,
    line6: 9.2342872363,
    line_animate: 9.3043043043,
  },
  {
    x: 0.985985986,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.8348348348,
    line4: 9.2242242242,
    line5: 9.2242242245,
    line6: 9.172391336,
    line_animate: 9.2242242242,
  },
  {
    x: 0.990990991,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.7747747748,
    line4: 9.1441441441,
    line5: 9.1441441444,
    line6: 9.1107929329,
    line_animate: 9.1441441441,
  },
  {
    x: 0.995995996,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.7147147147,
    line4: 9.0640640641,
    line5: 9.0640640643,
    line6: 9.0491945298,
    line_animate: 9.0640640641,
  },
  {
    x: 1.001001001,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.6546546547,
    line4: 8.983983984,
    line5: 8.9839839842,
    line6: 8.9878334524,
    line_animate: 8.983983984,
  },
  {
    x: 1.006006006,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.5945945946,
    line4: 8.9039039039,
    line5: 8.9039039042,
    line6: 8.9270847228,
    line_animate: 8.9039039039,
  },
  {
    x: 1.011011011,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.5345345345,
    line4: 8.8238238238,
    line5: 8.8238238241,
    line6: 8.8665070179,
    line_animate: 8.8238238238,
  },
  {
    x: 1.016016016,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.4744744745,
    line4: 8.7437437437,
    line5: 8.743743744,
    line6: 8.8062819431,
    line_animate: 8.7437437437,
  },
  {
    x: 1.021021021,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.4144144144,
    line4: 8.6636636637,
    line5: 8.6636636639,
    line6: 8.7464289091,
    line_animate: 8.6636636637,
  },
  {
    x: 1.026026026,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.3543543544,
    line4: 8.5835835836,
    line5: 8.5835835839,
    line6: 8.6867959079,
    line_animate: 8.5835835836,
  },
  {
    x: 1.031031031,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.2942942943,
    line4: 8.5035035035,
    line5: 8.5035035038,
    line6: 8.6274167193,
    line_animate: 8.5035035035,
  },
  {
    x: 1.036036036,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.2342342342,
    line4: 8.4234234234,
    line5: 8.4234234237,
    line6: 8.5681089303,
    line_animate: 8.4234234234,
  },
  {
    x: 1.041041041,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.1741741742,
    line4: 8.3433433433,
    line5: 8.3433433436,
    line6: 8.5089521137,
    line_animate: 8.3433433433,
  },
  {
    x: 1.046046046,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.1141141141,
    line4: 8.2632632633,
    line5: 8.2632632635,
    line6: 8.4500560269,
    line_animate: 8.2632632633,
  },
  {
    x: 1.0510510511,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.0540540541,
    line4: 8.1831831832,
    line5: 8.1831831835,
    line6: 8.3915047905,
    line_animate: 8.1831831832,
  },
  {
    x: 1.0560560561,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.993993994,
    line4: 8.1031031031,
    line5: 8.1031031034,
    line6: 8.3329535541,
    line_animate: 8.1031031031,
  },
  {
    x: 1.0610610611,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.9339339339,
    line4: 8.023023023,
    line5: 8.0230230233,
    line6: 8.2746446848,
    line_animate: 8.023023023,
  },
  {
    x: 1.0660660661,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.8738738739,
    line4: 7.9429429429,
    line5: 7.9429429432,
    line6: 8.2164008952,
    line_animate: 7.9429429429,
  },
  {
    x: 1.0710710711,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.8138138138,
    line4: 7.8628628629,
    line5: 7.8628628631,
    line6: 8.1584633228,
    line_animate: 7.8628628629,
  },
  {
    x: 1.0760760761,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.7537537538,
    line4: 7.7827827828,
    line5: 7.7827827831,
    line6: 8.1007209669,
    line_animate: 7.7827827828,
  },
  {
    x: 1.0810810811,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.6936936937,
    line4: 7.7027027027,
    line5: 7.702702703,
    line6: 8.0434114993,
    line_animate: 7.7027027027,
  },
  {
    x: 1.0860860861,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.6336336336,
    line4: 7.6226226226,
    line5: 7.6226226229,
    line6: 7.986111463,
    line_animate: 7.6226226226,
  },
  {
    x: 1.0910910911,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.5735735736,
    line4: 7.5425425425,
    line5: 7.5425425428,
    line6: 7.9288114267,
    line_animate: 7.5425425425,
  },
  {
    x: 1.0960960961,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.5135135135,
    line4: 7.4624624625,
    line5: 7.4624624628,
    line6: 7.8715814724,
    line_animate: 7.4624624625,
  },
  {
    x: 1.1011011011,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.4534534535,
    line4: 7.3823823824,
    line5: 7.3823823827,
    line6: 7.8145443706,
    line_animate: 7.3823823824,
  },
  {
    x: 1.1061061061,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.3933933934,
    line4: 7.3023023023,
    line5: 7.3023023026,
    line6: 7.7577403872,
    line_animate: 7.3023023023,
  },
  {
    x: 1.1111111111,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.3333333333,
    line4: 7.2222222222,
    line5: 7.2222222225,
    line6: 7.7009587368,
    line_animate: 7.2222222222,
  },
  {
    x: 1.1161161161,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.2732732733,
    line4: 7.1421421421,
    line5: 7.1421421424,
    line6: 7.6444018109,
    line_animate: 7.1421421421,
  },
  {
    x: 1.1211211211,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.2132132132,
    line4: 7.0620620621,
    line5: 7.0620620624,
    line6: 7.587844885,
    line_animate: 7.0620620621,
  },
  {
    x: 1.1261261261,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.1531531532,
    line4: 6.981981982,
    line5: 6.9819819823,
    line6: 7.5312879591,
    line_animate: 6.981981982,
  },
  {
    x: 1.1311311311,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.0930930931,
    line4: 6.9019019019,
    line5: 6.9019019022,
    line6: 7.4748944667,
    line_animate: 6.9019019019,
  },
  {
    x: 1.1361361361,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.033033033,
    line4: 6.8218218218,
    line5: 6.8218218221,
    line6: 7.4188288337,
    line_animate: 6.8218218218,
  },
  {
    x: 1.1411411411,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.972972973,
    line4: 6.7417417417,
    line5: 6.7417417421,
    line6: 7.3629405238,
    line_animate: 6.7417417417,
  },
  {
    x: 1.1461461461,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.9129129129,
    line4: 6.6616616617,
    line5: 6.661661662,
    line6: 7.3072457153,
    line_animate: 6.6616616617,
  },
  {
    x: 1.1511511512,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.8528528529,
    line4: 6.5815815816,
    line5: 6.5815815819,
    line6: 7.2517141678,
    line_animate: 6.5815815816,
  },
  {
    x: 1.1561561562,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.7927927928,
    line4: 6.5015015015,
    line5: 6.5015015018,
    line6: 7.1965436225,
    line_animate: 6.5015015015,
  },
  {
    x: 1.1611611612,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.7327327327,
    line4: 6.4214214214,
    line5: 6.4214214217,
    line6: 7.1417856007,
    line_animate: 6.4214214214,
  },
  {
    x: 1.1661661662,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.6726726727,
    line4: 6.3413413413,
    line5: 6.3413413417,
    line6: 7.0874278929,
    line_animate: 6.3413413413,
  },
  {
    x: 1.1711711712,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.6126126126,
    line4: 6.2612612613,
    line5: 6.2612612616,
    line6: 7.0330701852,
    line_animate: 6.2612612613,
  },
  {
    x: 1.1761761762,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.5525525526,
    line4: 6.1811811812,
    line5: 6.1811811815,
    line6: 6.9788811173,
    line_animate: 6.1811811812,
  },
  {
    x: 1.1811811812,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.4924924925,
    line4: 6.1011011011,
    line5: 6.1011011014,
    line6: 6.9249363033,
    line_animate: 6.1011011011,
  },
  {
    x: 1.1861861862,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.4324324324,
    line4: 6.021021021,
    line5: 6.0210210214,
    line6: 6.8713047963,
    line_animate: 6.021021021,
  },
  {
    x: 1.1911911912,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.3723723724,
    line4: 5.9409409409,
    line5: 5.9409409413,
    line6: 6.8176732893,
    line_animate: 5.9409409409,
  },
  {
    x: 1.1961961962,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.3123123123,
    line4: 5.8608608609,
    line5: 5.8608608612,
    line6: 6.7640417822,
    line_animate: 5.8608608609,
  },
  {
    x: 1.2012012012,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.2522522523,
    line4: 5.7807807808,
    line5: 5.7807807811,
    line6: 6.7107143512,
    line_animate: 5.7807807808,
  },
  {
    x: 1.2062062062,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.1921921922,
    line4: 5.7007007007,
    line5: 5.700700701,
    line6: 6.6575962172,
    line_animate: 5.7007007007,
  },
  {
    x: 1.2112112112,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.1321321321,
    line4: 5.6206206206,
    line5: 5.620620621,
    line6: 6.6049177756,
    line_animate: 5.6206206206,
  },
  {
    x: 1.2162162162,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.0720720721,
    line4: 5.5405405405,
    line5: 5.5405405409,
    line6: 6.5524424139,
    line_animate: 5.5405405405,
  },
  {
    x: 1.2212212212,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.012012012,
    line4: 5.4604604605,
    line5: 5.4604604608,
    line6: 6.5001608376,
    line_animate: 5.4604604605,
  },
  {
    x: 1.2262262262,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.951951952,
    line4: 5.3803803804,
    line5: 5.3803803807,
    line6: 6.4482073549,
    line_animate: 5.3803803804,
  },
  {
    x: 1.2312312312,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.8918918919,
    line4: 5.3003003003,
    line5: 5.3003003006,
    line6: 6.3963732563,
    line_animate: 5.3003003003,
  },
  {
    x: 1.2362362362,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.8318318318,
    line4: 5.2202202202,
    line5: 5.2202202206,
    line6: 6.3448913608,
    line_animate: 5.2202202202,
  },
  {
    x: 1.2412412412,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.7717717718,
    line4: 5.1401401401,
    line5: 5.1401401405,
    line6: 6.2934140819,
    line_animate: 5.1401401401,
  },
  {
    x: 1.2462462462,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.7117117117,
    line4: 5.0600600601,
    line5: 5.0600600604,
    line6: 6.2422040067,
    line_animate: 5.0600600601,
  },
  {
    x: 1.2512512513,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.6516516517,
    line4: 4.99332666,
    line5: 4.9799799803,
    line6: 6.1918476353,
    line_animate: 4.97997998,
  },
  {
    x: 1.2562562563,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.5915915916,
    line4: 4.9666333,
    line5: 4.8998999003,
    line6: 6.1419196881,
    line_animate: 4.8998998999,
  },
  {
    x: 1.2612612613,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.5315315315,
    line4: 4.9399399399,
    line5: 4.8198198202,
    line6: 6.0922937364,
    line_animate: 4.8198198198,
  },
  {
    x: 1.2662662663,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.4714714715,
    line4: 4.9132465799,
    line5: 4.7397397401,
    line6: 6.0427101173,
    line_animate: 4.7397397397,
  },
  {
    x: 1.2712712713,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.4114114114,
    line4: 4.8865532199,
    line5: 4.65965966,
    line6: 5.9933580278,
    line_animate: 4.6596596597,
  },
  {
    x: 1.2762762763,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.3513513514,
    line4: 4.8598598599,
    line5: 4.5795795799,
    line6: 5.9443574838,
    line_animate: 4.5795795796,
  },
  {
    x: 1.2812812813,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.2912912913,
    line4: 4.8331664998,
    line5: 4.4994994999,
    line6: 5.8959465469,
    line_animate: 4.4994994995,
  },
  {
    x: 1.2862862863,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.2312312312,
    line4: 4.8064731398,
    line5: 4.4194194198,
    line6: 5.8480144772,
    line_animate: 4.4194194194,
  },
  {
    x: 1.2912912913,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.1711711712,
    line4: 4.7797797798,
    line5: 4.3393393397,
    line6: 5.8004406154,
    line_animate: 4.3393393393,
  },
  {
    x: 1.2962962963,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.1111111111,
    line4: 4.7530864198,
    line5: 4.2592592596,
    line6: 5.7529675802,
    line_animate: 4.2592592593,
  },
  {
    x: 1.3013013013,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.0510510511,
    line4: 4.7263930597,
    line5: 4.1791791796,
    line6: 5.7054945451,
    line_animate: 4.1791791792,
  },
  {
    x: 1.3063063063,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.990990991,
    line4: 4.6996996997,
    line5: 4.0990990995,
    line6: 5.6580215099,
    line_animate: 4.0990990991,
  },
  {
    x: 1.3113113113,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.9309309309,
    line4: 4.6730063397,
    line5: 4.0190190194,
    line6: 5.6105645375,
    line_animate: 4.019019019,
  },
  {
    x: 1.3163163163,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.8708708709,
    line4: 4.6463129796,
    line5: 3.9389389393,
    line6: 5.5633235317,
    line_animate: 3.9389389389,
  },
  {
    x: 1.3213213213,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.8108108108,
    line4: 4.6196196196,
    line5: 3.8588588592,
    line6: 5.5160825258,
    line_animate: 3.8588588589,
  },
  {
    x: 1.3263263263,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.7507507508,
    line4: 4.5929262596,
    line5: 3.7787787792,
    line6: 5.46884152,
    line_animate: 3.7787787788,
  },
  {
    x: 1.3313313313,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.6906906907,
    line4: 4.5662328996,
    line5: 3.6986986991,
    line6: 5.4216005141,
    line_animate: 3.6986986987,
  },
  {
    x: 1.3363363363,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.6306306306,
    line4: 4.5395395395,
    line5: 3.618618619,
    line6: 5.3744114672,
    line_animate: 3.6186186186,
  },
  {
    x: 1.3413413413,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.5705705706,
    line4: 4.5128461795,
    line5: 3.5385385389,
    line6: 5.3275734137,
    line_animate: 3.5385385385,
  },
  {
    x: 1.3463463463,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.5105105105,
    line4: 4.4861528195,
    line5: 3.4584584589,
    line6: 5.2808313206,
    line_animate: 3.4584584585,
  },
  {
    x: 1.3513513514,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.4504504505,
    line4: 4.4594594595,
    line5: 3.3783783788,
    line6: 5.2342799957,
    line_animate: 3.3783783784,
  },
  {
    x: 1.3563563564,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.3903903904,
    line4: 4.4327660994,
    line5: 3.2982982987,
    line6: 5.1877286708,
    line_animate: 3.2982982983,
  },
  {
    x: 1.3613613614,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.3303303303,
    line4: 4.4060727394,
    line5: 3.2182182186,
    line6: 5.1412332304,
    line_animate: 3.2182182182,
  },
  {
    x: 1.3663663664,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.2702702703,
    line4: 4.3793793794,
    line5: 3.1381381385,
    line6: 5.0952850939,
    line_animate: 3.1381381381,
  },
  {
    x: 1.3713713714,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.2102102102,
    line4: 4.3526860194,
    line5: 3.0580580585,
    line6: 5.0498268995,
    line_animate: 3.0580580581,
  },
  {
    x: 1.3763763764,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.1501501502,
    line4: 4.3259926593,
    line5: 2.9779779784,
    line6: 5.0044159449,
    line_animate: 2.977977978,
  },
  {
    x: 1.3813813814,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.0900900901,
    line4: 4.2992992993,
    line5: 2.8978978983,
    line6: 4.9590212795,
    line_animate: 2.8978978979,
  },
  {
    x: 1.3863863864,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.03003003,
    line4: 4.2726059393,
    line5: 2.8178178182,
    line6: 4.9140801232,
    line_animate: 2.8178178178,
  },
  {
    x: 1.3913913914,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.96996997,
    line4: 4.2459125792,
    line5: 2.7377377381,
    line6: 4.8693490861,
    line_animate: 2.7377377377,
  },
  {
    x: 1.3963963964,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.9099099099,
    line4: 4.2192192192,
    line5: 2.6576576581,
    line6: 4.824618049,
    line_animate: 2.6576576577,
  },
  {
    x: 1.4014014014,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.8498498498,
    line4: 4.1925258592,
    line5: 2.577577578,
    line6: 4.780135992,
    line_animate: 2.5775775776,
  },
  {
    x: 1.4064064064,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.7897897898,
    line4: 4.1658324992,
    line5: 2.4974974979,
    line6: 4.7359376831,
    line_animate: 2.4974974975,
  },
  {
    x: 1.4114114114,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.7297297297,
    line4: 4.1391391391,
    line5: 2.4174174178,
    line6: 4.6921581395,
    line_animate: 2.4174174174,
  },
  {
    x: 1.4164164164,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.6696696697,
    line4: 4.1124457791,
    line5: 2.3373373378,
    line6: 4.6489092182,
    line_animate: 2.3373373373,
  },
  {
    x: 1.4214214214,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.6096096096,
    line4: 4.0857524191,
    line5: 2.2572572577,
    line6: 4.6062257721,
    line_animate: 2.2572572573,
  },
  {
    x: 1.4264264264,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.5495495495,
    line4: 4.0590590591,
    line5: 2.1771771776,
    line6: 4.5638587258,
    line_animate: 2.1771771772,
  },
  {
    x: 1.4314314314,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.4894894895,
    line4: 4.032365699,
    line5: 2.0970970975,
    line6: 4.521597461,
    line_animate: 2.0970970971,
  },
  {
    x: 1.4364364364,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.4294294294,
    line4: 4.005672339,
    line5: 2.0170170174,
    line6: 4.4793361962,
    line_animate: 2.017017017,
  },
  {
    x: 1.4414414414,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.3693693694,
    line4: 3.978978979,
    line5: 1.9369369374,
    line6: 4.4370749313,
    line_animate: 1.9369369369,
  },
  {
    x: 1.4464464464,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.3093093093,
    line4: 3.952285619,
    line5: 1.8568568573,
    line6: 4.3949944192,
    line_animate: 1.8568568569,
  },
  {
    x: 1.4514514515,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.2492492492,
    line4: 3.9255922589,
    line5: 1.7767767772,
    line6: 4.3532698847,
    line_animate: 1.7767767768,
  },
  {
    x: 1.4564564565,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.1891891892,
    line4: 3.8988988989,
    line5: 1.6966966971,
    line6: 4.3116743011,
    line_animate: 1.6966966967,
  },
  {
    x: 1.4614614615,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.1291291291,
    line4: 3.8722055389,
    line5: 1.6166166171,
    line6: 4.2700787175,
    line_animate: 1.6166166166,
  },
  {
    x: 1.4664664665,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.0690690691,
    line4: 3.8455121788,
    line5: 1.536536537,
    line6: 4.2285709108,
    line_animate: 1.5365365365,
  },
  {
    x: 1.4714714715,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.009009009,
    line4: 3.8188188188,
    line5: 1.4564564569,
    line6: 4.1877279675,
    line_animate: 1.4564564565,
  },
  {
    x: 1.4764764765,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.9489489489,
    line4: 3.7921254588,
    line5: 1.3763763768,
    line6: 4.147628524,
    line_animate: 1.3763763764,
  },
  {
    x: 1.4814814815,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.8888888889,
    line4: 3.7654320988,
    line5: 1.2962962967,
    line6: 4.1076924409,
    line_animate: 1.2962962963,
  },
  {
    x: 1.4864864865,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.8288288288,
    line4: 3.7387387387,
    line5: 1.2162162167,
    line6: 4.0680767972,
    line_animate: 1.2162162162,
  },
  {
    x: 1.4914914915,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.7687687688,
    line4: 3.7120453787,
    line5: 1.1361361366,
    line6: 4.0284611534,
    line_animate: 1.1361361361,
  },
  {
    x: 1.4964964965,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.7087087087,
    line4: 3.6853520187,
    line5: 1.0560560565,
    line6: 3.9890814609,
    line_animate: 1.0560560561,
  },
  {
    x: 1.5015015015,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.6486486486,
    line4: 3.6586586587,
    line5: 0.9759759764,
    line6: 3.9500925441,
    line_animate: 0.975975976,
  },
  {
    x: 1.5065065065,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.5885885886,
    line4: 3.6319652986,
    line5: 0.8958958964,
    line6: 3.9111315867,
    line_animate: 0.8958958959,
  },
  {
    x: 1.5115115115,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.5285285285,
    line4: 3.6052719386,
    line5: 0.8158158163,
    line6: 3.872301517,
    line_animate: 0.8158158158,
  },
  {
    x: 1.5165165165,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.4684684685,
    line4: 3.5785785786,
    line5: 0.7357357362,
    line6: 3.8339378613,
    line_animate: 0.7357357357,
  },
  {
    x: 1.5215215215,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.4084084084,
    line4: 3.5518852186,
    line5: 0.6556556561,
    line6: 3.7957601618,
    line_animate: 0.6556556557,
  },
  {
    x: 1.5265265265,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.3483483483,
    line4: 3.5251918585,
    line5: 0.575575576,
    line6: 3.7576667483,
    line_animate: 0.5755755756,
  },
  {
    x: 1.5315315315,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.2882882883,
    line4: 3.4984984985,
    line5: 0.495495496,
    line6: 3.7196964992,
    line_animate: 0.4954954955,
  },
  {
    x: 1.5365365365,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.2282282282,
    line4: 3.4718051385,
    line5: 0.4154154159,
    line6: 3.6818187811,
    line_animate: 0.4154154154,
  },
  {
    x: 1.5415415415,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.1681681682,
    line4: 3.4451117784,
    line5: 0.3353353358,
    line6: 3.6441928529,
    line_animate: 0.3353353353,
  },
  {
    x: 1.5465465465,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.1081081081,
    line4: 3.4184184184,
    line5: 0.2552552557,
    line6: 3.6067653443,
    line_animate: 0.2552552553,
  },
  {
    x: 1.5515515516,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.048048048,
    line4: 3.3917250584,
    line5: 0.1751751756,
    line6: 3.5695319163,
    line_animate: 0.1751751752,
  },
  {
    x: 1.5565565566,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.987987988,
    line4: 3.3650316984,
    line5: 0.0950950956,
    line6: 3.5323639202,
    line_animate: 0.0950950951,
  },
  {
    x: 1.5615615616,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.9279279279,
    line4: 3.3383383383,
    line5: 0.0150150155,
    line6: 3.4953442108,
    line_animate: 0.015015015,
  },
  {
    x: 1.5665665666,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.8678678679,
    line4: 3.3116449783,
    line5: -0.0650650646,
    line6: 3.4583245013,
    line_animate: -0.0650650651,
  },
  {
    x: 1.5715715716,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.8078078078,
    line4: 3.2849516183,
    line5: -0.1451451447,
    line6: 3.4213588864,
    line_animate: -0.1451451451,
  },
  {
    x: 1.5765765766,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.7477477477,
    line4: 3.2582582583,
    line5: -0.2252252247,
    line6: 3.3845520897,
    line_animate: -0.2252252252,
  },
  {
    x: 1.5815815816,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.6876876877,
    line4: 3.2315648982,
    line5: -0.3053053048,
    line6: 3.347957055,
    line_animate: -0.3053053053,
  },
  {
    x: 1.5865865866,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.6276276276,
    line4: 3.2048715382,
    line5: -0.3853853849,
    line6: 3.3114288623,
    line_animate: -0.3853853854,
  },
  {
    x: 1.5915915916,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.5675675676,
    line4: 3.1781781782,
    line5: -0.465465465,
    line6: 3.2750452968,
    line_animate: -0.4654654655,
  },
  {
    x: 1.5965965966,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.5075075075,
    line4: 3.1514848182,
    line5: -0.5455455451,
    line6: 3.2387495575,
    line_animate: -0.5455455455,
  },
  {
    x: 1.6016016016,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.4474474474,
    line4: 3.1247914581,
    line5: -0.6256256251,
    line6: 3.2028896292,
    line_animate: -0.6256256256,
  },
  {
    x: 1.6066066066,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.3873873874,
    line4: 3.0980980981,
    line5: -0.7057057052,
    line6: 3.1673118055,
    line_animate: -0.7057057057,
  },
  {
    x: 1.6116116116,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.3273273273,
    line4: 3.0714047381,
    line5: -0.7857857853,
    line6: 3.1319472561,
    line_animate: -0.7857857858,
  },
  {
    x: 1.6166166166,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.2672672673,
    line4: 3.044711378,
    line5: -0.8658658654,
    line6: 3.0966639588,
    line_animate: -0.8658658659,
  },
  {
    x: 1.6216216216,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.2072072072,
    line4: 3.018018018,
    line5: -0.9459459454,
    line6: 3.0616902603,
    line_animate: -0.9459459459,
  },
  {
    x: 1.6266266266,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.1471471471,
    line4: 2.991324658,
    line5: -1.0260260255,
    line6: 3.0272468718,
    line_animate: -1.026026026,
  },
  {
    x: 1.6316316316,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.0870870871,
    line4: 2.964631298,
    line5: -1.1061061056,
    line6: 2.9933215539,
    line_animate: -1.1061061061,
  },
  {
    x: 1.6366366366,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.027027027,
    line4: 2.9379379379,
    line5: -1.1861861857,
    line6: 2.9594503554,
    line_animate: -1.1861861862,
  },
  {
    x: 1.6416416416,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.966966967,
    line4: 2.9112445779,
    line5: -1.2662662658,
    line6: 2.9255791569,
    line_animate: -1.2662662663,
  },
  {
    x: 1.6466466466,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.9069069069,
    line4: 2.8845512179,
    line5: -1.3463463458,
    line6: 2.8918026903,
    line_animate: -1.3463463463,
  },
  {
    x: 1.6516516517,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.8468468468,
    line4: 2.8578578579,
    line5: -1.4264264259,
    line6: 2.8583332455,
    line_animate: -1.4264264264,
  },
  {
    x: 1.6566566567,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.7867867868,
    line4: 2.8311644978,
    line5: -1.506506506,
    line6: 2.824986096,
    line_animate: -1.5065065065,
  },
  {
    x: 1.6616616617,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.7267267267,
    line4: 2.8044711378,
    line5: -1.5865865861,
    line6: 2.7917350303,
    line_animate: -1.5865865866,
  },
  {
    x: 1.6666666667,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.6666666667,
    line4: 2.7777777778,
    line5: -1.6666666661,
    line6: 2.7586390906,
    line_animate: -1.6666666667,
  },
  {
    x: 1.6716716717,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.6066066066,
    line4: 2.7510844178,
    line5: -1.7467467462,
    line6: 2.7259992224,
    line_animate: -1.7467467467,
  },
  {
    x: 1.6766766767,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.5465465465,
    line4: 2.7243910577,
    line5: -1.8268268263,
    line6: 2.6933644579,
    line_animate: -1.8268268268,
  },
  {
    x: 1.6816816817,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.4864864865,
    line4: 2.6976976977,
    line5: -1.9069069064,
    line6: 2.6607296933,
    line_animate: -1.9069069069,
  },
  {
    x: 1.6866866867,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.4264264264,
    line4: 2.6710043377,
    line5: -1.9869869865,
    line6: 2.6283344942,
    line_animate: -1.986986987,
  },
  {
    x: 1.6916916917,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.3663663664,
    line4: 2.6443109776,
    line5: -2.0670670665,
    line6: 2.5961078511,
    line_animate: -2.0670670671,
  },
  {
    x: 1.6966966967,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.3063063063,
    line4: 2.6176176176,
    line5: -2.1471471466,
    line6: 2.5640044011,
    line_animate: -2.1471471471,
  },
  {
    x: 1.7017017017,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.2462462462,
    line4: 2.5909242576,
    line5: -2.2272272267,
    line6: 2.5319810749,
    line_animate: -2.2272272272,
  },
  {
    x: 1.7067067067,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.1861861862,
    line4: 2.5642308976,
    line5: -2.3073073068,
    line6: 2.5000375023,
    line_animate: -2.3073073073,
  },
  {
    x: 1.7117117117,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.1261261261,
    line4: 2.5375375375,
    line5: -2.3873873869,
    line6: 2.4682166624,
    line_animate: -2.3873873874,
  },
  {
    x: 1.7167167167,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.0660660661,
    line4: 2.5108441775,
    line5: -2.4674674669,
    line6: 2.4365198315,
    line_animate: -2.4674674675,
  },
  {
    x: 1.7217217217,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.006006006,
    line4: 2.4841508175,
    line5: -2.547547547,
    line6: 2.4049008096,
    line_animate: -2.5475475475,
  },
  {
    x: 1.7267267267,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.9459459459,
    line4: 2.4574574575,
    line5: -2.6276276271,
    line6: 2.3735210643,
    line_animate: -2.6276276276,
  },
  {
    x: 1.7317317317,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.8858858859,
    line4: 2.4307640974,
    line5: -2.7077077072,
    line6: 2.3425775915,
    line_animate: -2.7077077077,
  },
  {
    x: 1.7367367367,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.8258258258,
    line4: 2.4040707374,
    line5: -2.7877877872,
    line6: 2.3120173539,
    line_animate: -2.7877877878,
  },
  {
    x: 1.7417417417,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.7657657658,
    line4: 2.3773773774,
    line5: -2.8678678673,
    line6: 2.2820966272,
    line_animate: -2.8678678679,
  },
  {
    x: 1.7467467467,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.7057057057,
    line4: 2.3506840174,
    line5: -2.9479479474,
    line6: 2.2522818641,
    line_animate: -2.9479479479,
  },
  {
    x: 1.7517517518,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.6456456456,
    line4: 2.3239906573,
    line5: -3.0280280275,
    line6: 2.222467101,
    line_animate: -3.028028028,
  },
  {
    x: 1.7567567568,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.5855855856,
    line4: 2.2972972973,
    line5: -3.1081081076,
    line6: 2.1926523379,
    line_animate: -3.1081081081,
  },
  {
    x: 1.7617617618,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.5255255255,
    line4: 2.2706039373,
    line5: -3.1881881876,
    line6: 2.1628375748,
    line_animate: -3.1881881882,
  },
  {
    x: 1.7667667668,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.4654654655,
    line4: 2.2439105772,
    line5: -3.2682682677,
    line6: 2.1330228117,
    line_animate: -3.2682682683,
  },
  {
    x: 1.7717717718,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.4054054054,
    line4: 2.2172172172,
    line5: -3.3483483478,
    line6: 2.1036230926,
    line_animate: -3.3483483483,
  },
  {
    x: 1.7767767768,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.3453453453,
    line4: 2.1905238572,
    line5: -3.4284284279,
    line6: 2.0747331283,
    line_animate: -3.4284284284,
  },
  {
    x: 1.7817817818,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.2852852853,
    line4: 2.1638304972,
    line5: -3.5085085079,
    line6: 2.0462670842,
    line_animate: -3.5085085085,
  },
  {
    x: 1.7867867868,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.2252252252,
    line4: 2.1371371371,
    line5: -3.588588588,
    line6: 2.0182400043,
    line_animate: -3.5885885886,
  },
  {
    x: 1.7917917918,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.1651651652,
    line4: 2.1104437771,
    line5: -3.6686686681,
    line6: 1.9907986134,
    line_animate: -3.6686686687,
  },
  {
    x: 1.7967967968,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.1051051051,
    line4: 2.0837504171,
    line5: -3.7487487482,
    line6: 1.9635442997,
    line_animate: -3.7487487487,
  },
  {
    x: 1.8018018018,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.045045045,
    line4: 2.0570570571,
    line5: -3.8288288283,
    line6: 1.9363715231,
    line_animate: -3.8288288288,
  },
  {
    x: 1.8068068068,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.984984985,
    line4: 2.030363697,
    line5: -3.9089089083,
    line6: 1.9094057939,
    line_animate: -3.9089089089,
  },
  {
    x: 1.8118118118,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.9249249249,
    line4: 2.003670337,
    line5: -3.9889889884,
    line6: 1.8825418484,
    line_animate: -3.988988989,
  },
  {
    x: 1.8168168168,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.8648648649,
    line4: 1.976976977,
    line5: -4.0690690685,
    line6: 1.8557183737,
    line_animate: -4.0690690691,
  },
  {
    x: 1.8218218218,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.8048048048,
    line4: 1.950283617,
    line5: -4.1491491486,
    line6: 1.8290485837,
    line_animate: -4.1491491491,
  },
  {
    x: 1.8268268268,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.7447447447,
    line4: 1.9235902569,
    line5: -4.2292292286,
    line6: 1.8023787938,
    line_animate: -4.2292292292,
  },
  {
    x: 1.8318318318,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.6846846847,
    line4: 1.8968968969,
    line5: -4.3093093087,
    line6: 1.7757090038,
    line_animate: -4.3093093093,
  },
  {
    x: 1.8368368368,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.6246246246,
    line4: 1.8702035369,
    line5: -4.3893893888,
    line6: 1.7491135526,
    line_animate: -4.3893893894,
  },
  {
    x: 1.8418418418,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.5645645646,
    line4: 1.8435101768,
    line5: -4.4694694689,
    line6: 1.7231414672,
    line_animate: -4.4694694695,
  },
  {
    x: 1.8468468468,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.5045045045,
    line4: 1.8168168168,
    line5: -4.549549549,
    line6: 1.6975788192,
    line_animate: -4.5495495495,
  },
  {
    x: 1.8518518519,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.4444444444,
    line4: 1.7901234568,
    line5: -4.629629629,
    line6: 1.6720636402,
    line_animate: -4.6296296296,
  },
  {
    x: 1.8568568569,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.3843843844,
    line4: 1.7634300968,
    line5: -4.7097097091,
    line6: 1.6467363609,
    line_animate: -4.7097097097,
  },
  {
    x: 1.8618618619,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.3243243243,
    line4: 1.7367367367,
    line5: -4.7897897892,
    line6: 1.6218545228,
    line_animate: -4.7897897898,
  },
  {
    x: 1.8668668669,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.2642642643,
    line4: 1.7100433767,
    line5: -4.8698698693,
    line6: 1.5971674124,
    line_animate: -4.8698698699,
  },
  {
    x: 1.8718718719,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.2042042042,
    line4: 1.6833500167,
    line5: -4.9499499494,
    line6: 1.5727844804,
    line_animate: -4.9499499499,
  },
  {
    x: 1.8768768769,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.1441441441,
    line4: 1.6566566567,
    line5: -5.0300300294,
    line6: 1.548695487,
    line_animate: -5.03003003,
  },
  {
    x: 1.8818818819,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.0840840841,
    line4: 1.6299632966,
    line5: -5.1101101095,
    line6: 1.5247051545,
    line_animate: -5.1101101101,
  },
  {
    x: 1.8868868869,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.024024024,
    line4: 1.6032699366,
    line5: -5.1901901896,
    line6: 1.500714822,
    line_animate: -5.1901901902,
  },
  {
    x: 1.8918918919,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.963963964,
    line4: 1.5765765766,
    line5: -5.2702702697,
    line6: 1.4767244894,
    line_animate: -5.2702702703,
  },
  {
    x: 1.8968968969,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.9039039039,
    line4: 1.5498832165,
    line5: -5.3503503497,
    line6: 1.4530388851,
    line_animate: -5.3503503503,
  },
  {
    x: 1.9019019019,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.8438438438,
    line4: 1.5231898565,
    line5: -5.4304304298,
    line6: 1.4295817867,
    line_animate: -5.2782782783,
  },
  {
    x: 1.9069069069,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.7837837838,
    line4: 1.4964964965,
    line5: -5.5105105099,
    line6: 1.4061562061,
    line_animate: -4.957957958,
  },
  {
    x: 1.9119119119,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.7237237237,
    line4: 1.4698031365,
    line5: -5.59059059,
    line6: 1.3827860724,
    line_animate: -4.6376376376,
  },
  {
    x: 1.9169169169,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.6636636637,
    line4: 1.4431097764,
    line5: -5.6706706701,
    line6: 1.3595475457,
    line_animate: -4.3173173173,
  },
  {
    x: 1.9219219219,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.6036036036,
    line4: 1.4164164164,
    line5: -5.7507507501,
    line6: 1.3365898834,
    line_animate: -3.996996997,
  },
  {
    x: 1.9269269269,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.5435435435,
    line4: 1.3897230564,
    line5: -5.8308308302,
    line6: 1.3139006353,
    line_animate: -3.6766766767,
  },
  {
    x: 1.9319319319,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.4834834835,
    line4: 1.3630296964,
    line5: -5.9109109103,
    line6: 1.2914070456,
    line_animate: -3.3563563564,
  },
  {
    x: 1.9369369369,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.4234234234,
    line4: 1.3363363363,
    line5: -5.9909909904,
    line6: 1.2690565425,
    line_animate: -3.036036036,
  },
  {
    x: 1.9419419419,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.3633633634,
    line4: 1.3096429763,
    line5: -6.0710710704,
    line6: 1.2467483077,
    line_animate: -2.7157157157,
  },
  {
    x: 1.9469469469,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.3033033033,
    line4: 1.2829496163,
    line5: -6.1511511505,
    line6: 1.224440073,
    line_animate: -2.3953953954,
  },
  {
    x: 1.951951952,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.2432432432,
    line4: 1.2562562563,
    line5: -6.2312312306,
    line6: 1.2022269149,
    line_animate: -2.0750750751,
  },
  {
    x: 1.956956957,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.1831831832,
    line4: 1.2295628962,
    line5: -6.3113113107,
    line6: 1.1801864241,
    line_animate: -1.7547547548,
  },
  {
    x: 1.961961962,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.1231231231,
    line4: 1.2028695362,
    line5: -6.3913913908,
    line6: 1.1584295161,
    line_animate: -1.4344344344,
  },
  {
    x: 1.966966967,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.0630630631,
    line4: 1.1761761762,
    line5: -6.4714714708,
    line6: 1.1368233383,
    line_animate: -1.1141141141,
  },
  {
    x: 1.971971972,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.003003003,
    line4: 1.1494828161,
    line5: -6.5515515509,
    line6: 1.1155610506,
    line_animate: -0.7937937938,
  },
  {
    x: 1.976976977,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.0570570571,
    line4: 1.1227894561,
    line5: -6.631631631,
    line6: 1.0946565123,
    line_animate: -0.4734734735,
  },
  {
    x: 1.981981982,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.1171171171,
    line4: 1.0960960961,
    line5: -6.7117117111,
    line6: 1.0739951493,
    line_animate: -0.1531531532,
  },
  {
    x: 1.986986987,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.1771771772,
    line4: 1.0694027361,
    line5: -6.7917917911,
    line6: 1.0533337863,
    line_animate: 0.1671671672,
  },
  {
    x: 1.991991992,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.2372372372,
    line4: 1.042709376,
    line5: -5.2782782778,
    line6: 1.0326724233,
    line_animate: 0.4874874875,
  },
  {
    x: 1.996996997,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.2972972973,
    line4: 1.016016016,
    line5: -1.3543543543,
    line6: 1.0121799366,
    line_animate: 0.8078078078,
  },
  {
    x: 2.002002002,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.3573573574,
    line4: 0.989322656,
    line5: 2.5695695693,
    line6: 0.9918880575,
    line_animate: 1.1281281281,
  },
  {
    x: 2.007007007,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.4174174174,
    line4: 0.962629296,
    line5: 6.4934934928,
    line6: 0.97196873,
    line_animate: 1.4484484484,
  },
  {
    x: 2.012012012,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.4774774775,
    line4: 0.9359359359,
    line5: 10.4174174164,
    line6: 0.9525214054,
    line_animate: 1.7687687688,
  },
  {
    x: 2.017017017,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.5375375375,
    line4: 0.9092425759,
    line5: 14.3413413399,
    line6: 0.9335508458,
    line_animate: 2.0890890891,
  },
  {
    x: 2.022022022,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.5975975976,
    line4: 0.8825492159,
    line5: 18.2652652634,
    line6: 0.9153519907,
    line_animate: 2.4094094094,
  },
  {
    x: 2.027027027,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.6576576577,
    line4: 0.8558558559,
    line5: 22.189189187,
    line6: 0.8975245013,
    line_animate: 2.7297297297,
  },
  {
    x: 2.032032032,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.7177177177,
    line4: 0.8291624958,
    line5: 26.1131131105,
    line6: 0.8799218204,
    line_animate: 3.05005005,
  },
  {
    x: 2.037037037,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.7777777778,
    line4: 0.8024691358,
    line5: 30.037037034,
    line6: 0.8624157175,
    line_animate: 3.3703703704,
  },
  {
    x: 2.042042042,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.8378378378,
    line4: 0.7757757758,
    line5: 33.9609609576,
    line6: 0.8451853967,
    line_animate: 3.6906906907,
  },
  {
    x: 2.047047047,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.8978978979,
    line4: 0.7490824157,
    line5: 37.8848848811,
    line6: 0.828132394,
    line_animate: 4.011011011,
  },
  {
    x: 2.0520520521,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.957957958,
    line4: 0.7223890557,
    line5: 41.8088088046,
    line6: 0.8112639862,
    line_animate: 4.3313313313,
  },
  {
    x: 2.0570570571,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.018018018,
    line4: 0.6956956957,
    line5: 45.7327327282,
    line6: 0.7945767677,
    line_animate: 4.6516516516,
  },
  {
    x: 2.0620620621,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.0780780781,
    line4: 0.6690023357,
    line5: 49.6566566517,
    line6: 0.7782175972,
    line_animate: 4.971971972,
  },
  {
    x: 2.0670670671,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.1381381381,
    line4: 0.6423089756,
    line5: 53.5805805752,
    line6: 0.7621533717,
    line_animate: 5.2922922923,
  },
  {
    x: 2.0720720721,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.1981981982,
    line4: 0.6156156156,
    line5: 57.5045044988,
    line6: 0.7464859017,
    line_animate: 5.6126126126,
  },
  {
    x: 2.0770770771,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.2582582583,
    line4: 0.5889222556,
    line5: 61.4284284223,
    line6: 0.731192103,
    line_animate: 5.9329329329,
  },
  {
    x: 2.0820820821,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.3183183183,
    line4: 0.5622288956,
    line5: 65.3523523459,
    line6: 0.7159752005,
    line_animate: 6.2532532532,
  },
  {
    x: 2.0870870871,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.3783783784,
    line4: 0.5355355355,
    line5: 69.2762762694,
    line6: 0.7010062893,
    line_animate: 6.5735735736,
  },
  {
    x: 2.0920920921,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.4384384384,
    line4: 0.5088421755,
    line5: 73.2002001929,
    line6: 0.686131914,
    line_animate: 6.8938938939,
  },
  {
    x: 2.0970970971,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.4984984985,
    line4: 0.4821488155,
    line5: 77.1241241165,
    line6: 0.6712575387,
    line_animate: 7.2142142142,
  },
  {
    x: 2.1021021021,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.5585585586,
    line4: 0.4554554555,
    line5: 81.04804804,
    line6: 0.6565390854,
    line_animate: 7.5345345345,
  },
  {
    x: 2.1071071071,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.6186186186,
    line4: 0.4287620954,
    line5: 84.9719719635,
    line6: 0.6418464097,
    line_animate: 7.8548548548,
  },
  {
    x: 2.1121121121,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.6786786787,
    line4: 0.4020687354,
    line5: 88.8958958871,
    line6: 0.627153734,
    line_animate: 8.1751751752,
  },
  {
    x: 2.1171171171,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.7387387387,
    line4: 0.3753753754,
    line5: 92.8198198106,
    line6: 0.6125685399,
    line_animate: 8.4954954955,
  },
  {
    x: 2.1221221221,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.7987987988,
    line4: 0.3486820153,
    line5: 96.7437437341,
    line6: 0.5980577923,
    line_animate: 8.8158158158,
  },
  {
    x: 2.1271271271,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.8588588589,
    line4: 0.3219886553,
    line5: 100.6676676577,
    line6: 0.5835470447,
    line_animate: 9.1361361361,
  },
  {
    x: 2.1321321321,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.9189189189,
    line4: 0.2952952953,
    line5: 104.5915915812,
    line6: 0.5691782634,
    line_animate: 9.4564564564,
  },
  {
    x: 2.1371371371,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.978978979,
    line4: 0.2686019353,
    line5: 108.5155155047,
    line6: 0.5551839421,
    line_animate: 9.7767767768,
  },
  {
    x: 2.1421421421,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.039039039,
    line4: 0.2419085752,
    line5: 112.4394394283,
    line6: 0.5417542867,
    line_animate: 10.0970970971,
  },
  {
    x: 2.1471471471,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.0990990991,
    line4: 0.2152152152,
    line5: 116.3633633518,
    line6: 0.5286587229,
    line_animate: 10.4174174174,
  },
  {
    x: 2.1521521522,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.1591591592,
    line4: 0.1885218552,
    line5: 120.2872872754,
    line6: 0.5156058748,
    line_animate: 10.7377377377,
  },
  {
    x: 2.1571571572,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.2192192192,
    line4: 0.1618284952,
    line5: 124.2112111989,
    line6: 0.5027136361,
    line_animate: 11.058058058,
  },
  {
    x: 2.1621621622,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.2792792793,
    line4: 0.1351351351,
    line5: 128.1351351224,
    line6: 0.4898979849,
    line_animate: 11.3783783784,
  },
  {
    x: 2.1671671672,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.3393393393,
    line4: 0.1084417751,
    line5: 132.059059046,
    line6: 0.4772283535,
    line_animate: 11.6986986987,
  },
  {
    x: 2.1721721722,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.3993993994,
    line4: 0.0817484151,
    line5: 135.9829829695,
    line6: 0.4647232112,
    line_animate: 12.019019019,
  },
  {
    x: 2.1771771772,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.4594594595,
    line4: 0.0550550551,
    line5: 139.906906893,
    line6: 0.4522180689,
    line_animate: 12.3393393393,
  },
  {
    x: 2.1821821822,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.5195195195,
    line4: 0.028361695,
    line5: 143.8308308166,
    line6: 0.4397129266,
    line_animate: 12.6596596596,
  },
  {
    x: 2.1871871872,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.5795795796,
    line4: 0.001668335,
    line5: 147.7547547401,
    line6: 0.4272077843,
    line_animate: 12.97997998,
  },
  {
    x: 2.1921921922,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.6396396396,
    line4: -0.025025025,
    line5: 151.6786786636,
    line6: 0.4148691015,
    line_animate: 13.3003003003,
  },
  {
    x: 2.1971971972,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.6996996997,
    line4: -0.0517183851,
    line5: 155.6026025872,
    line6: 0.4025469134,
    line_animate: 13.6206206206,
  },
  {
    x: 2.2022022022,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.7597597598,
    line4: -0.0784117451,
    line5: 159.5265265107,
    line6: 0.3902247252,
    line_animate: 13.9409409409,
  },
  {
    x: 2.2072072072,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.8198198198,
    line4: -0.1051051051,
    line5: 163.4504504342,
    line6: 0.3780347496,
    line_animate: 14.2612612612,
  },
  {
    x: 2.2122122122,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.8798798799,
    line4: -0.1317984651,
    line5: 167.3743743578,
    line6: 0.3661460802,
    line_animate: 14.5815815816,
  },
  {
    x: 2.2172172172,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.9399399399,
    line4: -0.1584918252,
    line5: 171.2982982813,
    line6: 0.3543735684,
    line_animate: 14.9019019019,
  },
  {
    x: 2.2222222222,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.0,
    line4: -0.1851851852,
    line5: 175.2222222049,
    line6: 0.3426010565,
    line_animate: 15.2222222222,
  },
  {
    x: 2.2272272272,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.0600600601,
    line4: -0.2118785452,
    line5: 179.1461461284,
    line6: 0.3308285447,
    line_animate: 15.5425425425,
  },
  {
    x: 2.2322322322,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.1201201201,
    line4: -0.2385719052,
    line5: 183.0700700519,
    line6: 0.3191837564,
    line_animate: 15.8628628628,
  },
  {
    x: 2.2372372372,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.1801801802,
    line4: -0.2652652653,
    line5: 186.9939939755,
    line6: 0.3079042885,
    line_animate: 16.1831831832,
  },
  {
    x: 2.2422422422,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.2402402402,
    line4: -0.2919586253,
    line5: 190.917917899,
    line6: 0.2966824809,
    line_animate: 16.5035035035,
  },
  {
    x: 2.2472472472,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.3003003003,
    line4: -0.3186519853,
    line5: 194.8418418225,
    line6: 0.2855136572,
    line_animate: 16.8238238238,
  },
  {
    x: 2.2522522523,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.3603603604,
    line4: -0.3453453453,
    line5: 198.7657657461,
    line6: 0.274783508,
    line_animate: 17.1441441441,
  },
  {
    x: 2.2572572573,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.4204204204,
    line4: -0.3720387054,
    line5: 202.6896896696,
    line6: 0.2642730055,
    line_animate: 17.4644644644,
  },
  {
    x: 2.2622622623,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.4804804805,
    line4: -0.3987320654,
    line5: 206.6136135931,
    line6: 0.2538543558,
    line_animate: 17.7847847848,
  },
  {
    x: 2.2672672673,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.5405405405,
    line4: -0.4254254254,
    line5: 210.5375375167,
    line6: 0.2439086098,
    line_animate: 18.1051051051,
  },
  {
    x: 2.2722722723,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.6006006006,
    line4: -0.4521187855,
    line5: 214.4614614402,
    line6: 0.2339739979,
    line_animate: 18.4254254254,
  },
  {
    x: 2.2772772773,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.6606606607,
    line4: -0.4788121455,
    line5: 218.3853853637,
    line6: 0.2242184706,
    line_animate: 18.7457457457,
  },
  {
    x: 2.2822822823,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.7207207207,
    line4: -0.5055055055,
    line5: 222.3093092873,
    line6: 0.2148017278,
    line_animate: 19.066066066,
  },
  {
    x: 2.2872872873,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.7807807808,
    line4: -0.5321988655,
    line5: 226.2332332108,
    line6: 0.2054196792,
    line_animate: 19.3863863864,
  },
  {
    x: 2.2922922923,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.8408408408,
    line4: -0.5588922256,
    line5: 230.1571571344,
    line6: 0.1961924874,
    line_animate: 19.7067067067,
  },
  {
    x: 2.2972972973,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.9009009009,
    line4: -0.5855855856,
    line5: 234.0810810579,
    line6: 0.1871711771,
    line_animate: 20.027027027,
  },
  {
    x: 2.3023023023,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.960960961,
    line4: -0.6122789456,
    line5: 238.0050049814,
    line6: 0.1781579044,
    line_animate: 20.3473473473,
  },
  {
    x: 2.3073073073,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.021021021,
    line4: -0.6389723056,
    line5: 241.928928905,
    line6: 0.169273364,
    line_animate: 20.6676676676,
  },
  {
    x: 2.3123123123,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.0810810811,
    line4: -0.6656656657,
    line5: 245.8528528285,
    line6: 0.1606292933,
    line_animate: 20.987987988,
  },
  {
    x: 2.3173173173,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.1411411411,
    line4: -0.6923590257,
    line5: 249.776776752,
    line6: 0.1522995095,
    line_animate: 21.3083083083,
  },
  {
    x: 2.3223223223,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.2012012012,
    line4: -0.7190523857,
    line5: 253.7007006756,
    line6: 0.1442490969,
    line_animate: 21.6286286286,
  },
  {
    x: 2.3273273273,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.2612612613,
    line4: -0.7457457457,
    line5: 257.6246245991,
    line6: 0.1363440232,
    line_animate: 21.9489489489,
  },
  {
    x: 2.3323323323,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.3213213213,
    line4: -0.7724391058,
    line5: 261.5485485226,
    line6: 0.1286307791,
    line_animate: 22.2692692692,
  },
  {
    x: 2.3373373373,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.3813813814,
    line4: -0.7991324658,
    line5: 265.4724724462,
    line6: 0.1212219665,
    line_animate: 22.5895895896,
  },
  {
    x: 2.3423423423,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.4414414414,
    line4: -0.8258258258,
    line5: 269.3963963697,
    line6: 0.1138717672,
    line_animate: 22.9099099099,
  },
  {
    x: 2.3473473473,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.5015015015,
    line4: -0.8525191859,
    line5: 273.3203202932,
    line6: 0.1066433445,
    line_animate: 23.2302302302,
  },
  {
    x: 2.3523523524,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.5615615616,
    line4: -0.8792125459,
    line5: 277.2442442168,
    line6: 0.0996627135,
    line_animate: 23.5505505505,
  },
  {
    x: 2.3573573574,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.6216216216,
    line4: -0.9059059059,
    line5: 281.1681681403,
    line6: 0.0926828378,
    line_animate: 23.8708708708,
  },
  {
    x: 2.3623623624,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.6816816817,
    line4: -0.9325992659,
    line5: 285.0920920639,
    line6: 0.0862271013,
    line_animate: 24.1911911912,
  },
  {
    x: 2.3673673674,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.7417417417,
    line4: -0.959292626,
    line5: 289.0160159874,
    line6: 0.0802054084,
    line_animate: 24.5115115115,
  },
  {
    x: 2.3723723724,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.8018018018,
    line4: -0.985985986,
    line5: 292.9399399109,
    line6: 0.074337759,
    line_animate: 24.8318318318,
  },
  {
    x: 2.3773773774,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.8618618619,
    line4: -1.012679346,
    line5: 296.8638638345,
    line6: 0.0686205514,
    line_animate: 25.1521521521,
  },
  {
    x: 2.3823823824,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.9219219219,
    line4: -1.039372706,
    line5: 300.787787758,
    line6: 0.0632203269,
    line_animate: 25.4724724724,
  },
  {
    x: 2.3873873874,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.981981982,
    line4: -1.0660660661,
    line5: 304.7117116815,
    line6: 0.0579094665,
    line_animate: 25.7927927928,
  },
  {
    x: 2.3923923924,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.042042042,
    line4: -1.0927594261,
    line5: 308.6356356051,
    line6: 0.052598606,
    line_animate: 26.1131131131,
  },
  {
    x: 2.3973973974,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.1021021021,
    line4: -1.1194527861,
    line5: 312.5595595286,
    line6: 0.0474685556,
    line_animate: 26.4334334334,
  },
  {
    x: 2.4024024024,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.1621621622,
    line4: -1.1461461461,
    line5: 316.4834834521,
    line6: 0.042638432,
    line_animate: 26.7537537537,
  },
  {
    x: 2.4074074074,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.2222222222,
    line4: -1.1728395062,
    line5: 320.4074073757,
    line6: 0.0379114029,
    line_animate: 27.074074074,
  },
  {
    x: 2.4124124124,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.2822822823,
    line4: -1.1995328662,
    line5: 324.3313312992,
    line6: 0.0333441677,
    line_animate: 27.3943943944,
  },
  {
    x: 2.4174174174,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.3423423423,
    line4: -1.2262262262,
    line5: 328.2552552227,
    line6: 0.0289330457,
    line_animate: 27.7147147147,
  },
  {
    x: 2.4224224224,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.4024024024,
    line4: -1.2529195863,
    line5: 332.1791791463,
    line6: 0.0248121732,
    line_animate: 28.035035035,
  },
  {
    x: 2.4274274274,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.4624624625,
    line4: -1.2796129463,
    line5: 336.1031030698,
    line6: 0.020989644,
    line_animate: 28.3553553553,
  },
  {
    x: 2.4324324324,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.5225225225,
    line4: -1.3063063063,
    line5: 340.0270269933,
    line6: 0.017341918,
    line_animate: 28.6756756756,
  },
  {
    x: 2.4374374374,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.5825825826,
    line4: -1.3329996663,
    line5: 343.9509509169,
    line6: 0.0137493354,
    line_animate: 28.995995996,
  },
  {
    x: 2.4424424424,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.6426426426,
    line4: -1.3596930264,
    line5: 347.8748748404,
    line6: 0.0102995399,
    line_animate: 29.3163163163,
  },
  {
    x: 2.4474474474,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.7027027027,
    line4: -1.3863863864,
    line5: 351.798798764,
    line6: 0.0069581705,
    line_animate: 29.6366366366,
  },
  {
    x: 2.4524524525,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.7627627628,
    line4: -1.4130797464,
    line5: 355.7227226875,
    line6: 0.003694917,
    line_animate: 29.9569569569,
  },
  {
    x: 2.4574574575,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.8228228228,
    line4: -1.4397731064,
    line5: 359.646646611,
    line6: 0.000459213,
    line_animate: 30.2772772772,
  },
  {
    x: 2.4624624625,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.8828828829,
    line4: -1.4664664665,
    line5: 363.5705705346,
    line6: -0.0024306062,
    line_animate: 30.5975975976,
  },
  {
    x: 2.4674674675,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.9429429429,
    line4: -1.4931598265,
    line5: 367.4944944581,
    line6: -0.0053204253,
    line_animate: 30.9179179179,
  },
  {
    x: 2.4724724725,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.003003003,
    line4: -1.5198531865,
    line5: 371.4184183816,
    line6: -0.0082102444,
    line_animate: 31.2382382382,
  },
  {
    x: 2.4774774775,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.0630630631,
    line4: -1.5465465465,
    line5: 375.3423423052,
    line6: -0.0110598997,
    line_animate: 31.5585585585,
  },
  {
    x: 2.4824824825,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.1231231231,
    line4: -1.5732399066,
    line5: 379.2662662287,
    line6: -0.0135411287,
    line_animate: 31.8788788788,
  },
  {
    x: 2.4874874875,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.1831831832,
    line4: -1.5999332666,
    line5: 383.1901901522,
    line6: -0.0158698999,
    line_animate: 32.1991991992,
  },
  {
    x: 2.4924924925,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.2432432432,
    line4: -1.6266266266,
    line5: 387.1141140758,
    line6: -0.0179209055,
    line_animate: 32.5195195195,
  },
  {
    x: 2.4974974975,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.3033033033,
    line4: -1.6533199867,
    line5: 391.0380379993,
    line6: -0.0198753572,
    line_animate: 32.8398398398,
  },
  {
    x: 2.5025025025,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.3033033033,
    line4: -1.6533199867,
    line5: 391.0380379993,
    line6: -0.0218298089,
    line_animate: 32.8398398398,
  },
  {
    x: 2.5075075075,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.2432432432,
    line4: -1.6266266266,
    line5: 387.1141140758,
    line6: -0.023644873,
    line_animate: 32.5195195195,
  },
  {
    x: 2.5125125125,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.1831831832,
    line4: -1.5999332666,
    line5: 383.1901901522,
    line6: -0.0249422038,
    line_animate: 32.1991991992,
  },
  {
    x: 2.5175175175,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.1231231231,
    line4: -1.5732399066,
    line5: 379.2662662287,
    line6: -0.0261469877,
    line_animate: 31.8788788788,
  },
  {
    x: 2.5225225225,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.0630630631,
    line4: -1.5465465465,
    line5: 375.3423423052,
    line6: -0.0270951952,
    line_animate: 31.5585585585,
  },
  {
    x: 2.5275275275,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -6.003003003,
    line4: -1.5198531865,
    line5: 371.4184183816,
    line6: -0.0278547355,
    line_animate: 31.2382382382,
  },
  {
    x: 2.5325325325,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.9429429429,
    line4: -1.4931598265,
    line5: 367.4944944581,
    line6: -0.0284936812,
    line_animate: 30.9179179179,
  },
  {
    x: 2.5375375375,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.8828828829,
    line4: -1.4664664665,
    line5: 363.5705705346,
    line6: -0.0286524205,
    line_animate: 30.5975975976,
  },
  {
    x: 2.5425425425,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.8228228228,
    line4: -1.4397731064,
    line5: 359.646646611,
    line6: -0.0286270974,
    line_animate: 30.2772772772,
  },
  {
    x: 2.5475475475,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.7627627628,
    line4: -1.4130797464,
    line5: 355.7227226875,
    line6: -0.0284818276,
    line_animate: 29.9569569569,
  },
  {
    x: 2.5525525526,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.7027027027,
    line4: -1.3863863864,
    line5: 351.798798764,
    line6: -0.0278615393,
    line_animate: 29.6366366366,
  },
  {
    x: 2.5575575576,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.6426426426,
    line4: -1.3596930264,
    line5: 347.8748748404,
    line6: -0.0271883208,
    line_animate: 29.3163163163,
  },
  {
    x: 2.5625625626,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.5825825826,
    line4: -1.3329996663,
    line5: 343.9509509169,
    line6: -0.0264634918,
    line_animate: 28.995995996,
  },
  {
    x: 2.5675675676,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.5225225225,
    line4: -1.3063063063,
    line5: 340.0270269934,
    line6: -0.0254727411,
    line_animate: 28.6756756756,
  },
  {
    x: 2.5725725726,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.4624624625,
    line4: -1.2796129463,
    line5: 336.1031030698,
    line6: -0.0239593246,
    line_animate: 28.3553553553,
  },
  {
    x: 2.5775775776,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.4024024024,
    line4: -1.2529195863,
    line5: 332.1791791463,
    line6: -0.0223449052,
    line_animate: 28.035035035,
  },
  {
    x: 2.5825825826,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.3423423423,
    line4: -1.2262262262,
    line5: 328.2552552228,
    line6: -0.0207304858,
    line_animate: 27.7147147147,
  },
  {
    x: 2.5875875876,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.2822822823,
    line4: -1.1995328662,
    line5: 324.3313312992,
    line6: -0.0187273719,
    line_animate: 27.3943943944,
  },
  {
    x: 2.5925925926,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.2222222222,
    line4: -1.1728395062,
    line5: 320.4074073757,
    line6: -0.0163951516,
    line_animate: 27.074074074,
  },
  {
    x: 2.5975975976,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.1621621622,
    line4: -1.1461461461,
    line5: 316.4834834522,
    line6: -0.0138854606,
    line_animate: 26.7537537537,
  },
  {
    x: 2.6026026026,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.1021021021,
    line4: -1.1194527861,
    line5: 312.5595595286,
    line6: -0.0112204048,
    line_animate: 26.4334334334,
  },
  {
    x: 2.6076076076,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -5.042042042,
    line4: -1.0927594261,
    line5: 308.6356356051,
    line6: -0.0084746207,
    line_animate: 26.1131131131,
  },
  {
    x: 2.6126126126,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.981981982,
    line4: -1.0660660661,
    line5: 304.7117116816,
    line6: -0.0056879125,
    line_animate: 25.7927927928,
  },
  {
    x: 2.6176176176,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.9219219219,
    line4: -1.039372706,
    line5: 300.787787758,
    line6: -0.0026933222,
    line_animate: 25.4724724724,
  },
  {
    x: 2.6226226226,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.8618618619,
    line4: -1.012679346,
    line5: 296.8638638345,
    line6: 0.0004515376,
    line_animate: 25.1521521521,
  },
  {
    x: 2.6276276276,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.8018018018,
    line4: -0.985985986,
    line5: 292.939939911,
    line6: 0.0040722442,
    line_animate: 24.8318318318,
  },
  {
    x: 2.6326326326,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.7417417417,
    line4: -0.959292626,
    line5: 289.0160159874,
    line6: 0.0085392931,
    line_animate: 24.5115115115,
  },
  {
    x: 2.6376376376,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.6816816817,
    line4: -0.9325992659,
    line5: 285.0920920639,
    line6: 0.0132897445,
    line_animate: 24.1911911912,
  },
  {
    x: 2.6426426426,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.6216216216,
    line4: -0.9059059059,
    line5: 281.1681681404,
    line6: 0.0186255053,
    line_animate: 23.8708708708,
  },
  {
    x: 2.6476476476,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.5615615616,
    line4: -0.8792125459,
    line5: 277.2442442168,
    line6: 0.0244378756,
    line_animate: 23.5505505505,
  },
  {
    x: 2.6526526527,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.5015015015,
    line4: -0.8525191859,
    line5: 273.3203202933,
    line6: 0.0303990471,
    line_animate: 23.2302302302,
  },
  {
    x: 2.6576576577,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.4414414414,
    line4: -0.8258258258,
    line5: 269.3963963698,
    line6: 0.0366921109,
    line_animate: 22.9099099099,
  },
  {
    x: 2.6626626627,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.3813813814,
    line4: -0.7991324658,
    line5: 265.4724724462,
    line6: 0.0432870363,
    line_animate: 22.5895895896,
  },
  {
    x: 2.6676676677,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.3213213213,
    line4: -0.7724391058,
    line5: 261.5485485227,
    line6: 0.0503226239,
    line_animate: 22.2692692692,
  },
  {
    x: 2.6726726727,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.2612612613,
    line4: -0.7457457457,
    line5: 257.6246245991,
    line6: 0.0574209913,
    line_animate: 21.9489489489,
  },
  {
    x: 2.6776776777,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.2012012012,
    line4: -0.7190523857,
    line5: 253.7007006756,
    line6: 0.064616736,
    line_animate: 21.6286286286,
  },
  {
    x: 2.6826826827,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.1411411411,
    line4: -0.6923590257,
    line5: 249.7767767521,
    line6: 0.0719797001,
    line_animate: 21.3083083083,
  },
  {
    x: 2.6876876877,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.0810810811,
    line4: -0.6656656657,
    line5: 245.8528528285,
    line6: 0.0794576697,
    line_animate: 20.987987988,
  },
  {
    x: 2.6926926927,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -4.021021021,
    line4: -0.6389723056,
    line5: 241.928928905,
    line6: 0.0869356393,
    line_animate: 20.6676676676,
  },
  {
    x: 2.6976976977,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.960960961,
    line4: -0.6122789456,
    line5: 238.0050049815,
    line6: 0.0945578797,
    line_animate: 20.3473473473,
  },
  {
    x: 2.7027027027,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.9009009009,
    line4: -0.5855855856,
    line5: 234.0810810579,
    line6: 0.1022334961,
    line_animate: 20.027027027,
  },
  {
    x: 2.7077077077,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.8408408408,
    line4: -0.5588922256,
    line5: 230.1571571344,
    line6: 0.1105101456,
    line_animate: 19.7067067067,
  },
  {
    x: 2.7127127127,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.7807807808,
    line4: -0.5321988655,
    line5: 226.2332332109,
    line6: 0.1191289993,
    line_animate: 19.3863863864,
  },
  {
    x: 2.7177177177,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.7207207207,
    line4: -0.5055055055,
    line5: 222.3093092873,
    line6: 0.127902528,
    line_animate: 19.066066066,
  },
  {
    x: 2.7227227227,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.6606606607,
    line4: -0.4788121455,
    line5: 218.3853853638,
    line6: 0.1369013318,
    line_animate: 18.7457457457,
  },
  {
    x: 2.7277277277,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.6006006006,
    line4: -0.4521187855,
    line5: 214.4614614403,
    line6: 0.1460540789,
    line_animate: 18.4254254254,
  },
  {
    x: 2.7327327327,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.5405405405,
    line4: -0.4254254254,
    line5: 210.5375375167,
    line6: 0.1556217001,
    line_animate: 18.1051051051,
  },
  {
    x: 2.7377377377,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.4804804805,
    line4: -0.3987320654,
    line5: 206.6136135932,
    line6: 0.1653832136,
    line_animate: 17.7847847848,
  },
  {
    x: 2.7427427427,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.4204204204,
    line4: -0.3720387054,
    line5: 202.6896896697,
    line6: 0.1751846134,
    line_animate: 17.4644644644,
  },
  {
    x: 2.7477477477,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.3603603604,
    line4: -0.3453453453,
    line5: 198.7657657461,
    line6: 0.1851368187,
    line_animate: 17.1441441441,
  },
  {
    x: 2.7527527528,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.3003003003,
    line4: -0.3186519853,
    line5: 194.8418418226,
    line6: 0.1951466904,
    line_animate: 16.8238238238,
  },
  {
    x: 2.7577577578,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.2402402402,
    line4: -0.2919586253,
    line5: 190.9179178991,
    line6: 0.205289721,
    line_animate: 16.5035035035,
  },
  {
    x: 2.7627627628,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.1801801802,
    line4: -0.2652652653,
    line5: 186.9939939755,
    line6: 0.2155095511,
    line_animate: 16.1831831832,
  },
  {
    x: 2.7677677678,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.1201201201,
    line4: -0.2385719052,
    line5: 183.070070052,
    line6: 0.2261595315,
    line_animate: 15.8628628628,
  },
  {
    x: 2.7727727728,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.0600600601,
    line4: -0.2118785452,
    line5: 179.1461461285,
    line6: 0.2372319324,
    line_animate: 15.5425425425,
  },
  {
    x: 2.7777777778,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -3.0,
    line4: -0.1851851852,
    line5: 175.2222222049,
    line6: 0.2487305925,
    line_animate: 15.2222222222,
  },
  {
    x: 2.7827827828,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.9399399399,
    line4: -0.1584918252,
    line5: 171.2982982814,
    line6: 0.2604986047,
    line_animate: 14.9019019019,
  },
  {
    x: 2.7877877878,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.8798798799,
    line4: -0.1317984651,
    line5: 167.3743743579,
    line6: 0.2725250369,
    line_animate: 14.5815815816,
  },
  {
    x: 2.7927927928,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.8198198198,
    line4: -0.1051051051,
    line5: 163.4504504343,
    line6: 0.2849370243,
    line_animate: 14.2612612612,
  },
  {
    x: 2.7977977978,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.7597597598,
    line4: -0.0784117451,
    line5: 159.5265265108,
    line6: 0.2975246687,
    line_animate: 13.9409409409,
  },
  {
    x: 2.8028028028,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.6996996997,
    line4: -0.0517183851,
    line5: 155.6026025873,
    line6: 0.3102578996,
    line_animate: 13.6206206206,
  },
  {
    x: 2.8078078078,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.6396396396,
    line4: -0.025025025,
    line5: 151.6786786637,
    line6: 0.3232622452,
    line_animate: 13.3003003003,
  },
  {
    x: 2.8128128128,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.5795795796,
    line4: 0.001668335,
    line5: 147.7547547402,
    line6: 0.3366122843,
    line_animate: 12.97997998,
  },
  {
    x: 2.8178178178,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.5195195195,
    line4: 0.028361695,
    line5: 143.8308308167,
    line6: 0.35000674,
    line_animate: 12.6596596596,
  },
  {
    x: 2.8228228228,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.4594594595,
    line4: 0.0550550551,
    line5: 139.9069068931,
    line6: 0.3635750359,
    line_animate: 12.3393393393,
  },
  {
    x: 2.8278278278,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.3993993994,
    line4: 0.0817484151,
    line5: 135.9829829696,
    line6: 0.377458852,
    line_animate: 12.019019019,
  },
  {
    x: 2.8328328328,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.3393393393,
    line4: 0.1084417751,
    line5: 132.0590590461,
    line6: 0.3915900361,
    line_animate: 11.6986986987,
  },
  {
    x: 2.8378378378,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.2792792793,
    line4: 0.1351351351,
    line5: 128.1351351225,
    line6: 0.4059181722,
    line_animate: 11.3783783784,
  },
  {
    x: 2.8428428428,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.2192192192,
    line4: 0.1618284952,
    line5: 124.211211199,
    line6: 0.4206560197,
    line_animate: 11.058058058,
  },
  {
    x: 2.8478478478,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.1591591592,
    line4: 0.1885218552,
    line5: 120.2872872754,
    line6: 0.4358941971,
    line_animate: 10.7377377377,
  },
  {
    x: 2.8528528529,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.0990990991,
    line4: 0.2152152152,
    line5: 116.3633633519,
    line6: 0.4513086986,
    line_animate: 10.4174174174,
  },
  {
    x: 2.8578578579,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -2.039039039,
    line4: 0.2419085752,
    line5: 112.4394394284,
    line6: 0.4671719958,
    line_animate: 10.0970970971,
  },
  {
    x: 2.8628628629,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.978978979,
    line4: 0.2686019353,
    line5: 108.5155155048,
    line6: 0.4832960198,
    line_animate: 9.7767767768,
  },
  {
    x: 2.8678678679,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.9189189189,
    line4: 0.2952952953,
    line5: 104.5915915813,
    line6: 0.499659505,
    line_animate: 9.4564564564,
  },
  {
    x: 2.8728728729,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.8588588589,
    line4: 0.3219886553,
    line5: 100.6676676578,
    line6: 0.5165452024,
    line_animate: 9.1361361361,
  },
  {
    x: 2.8778778779,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.7987987988,
    line4: 0.3486820153,
    line5: 96.7437437342,
    line6: 0.5337327881,
    line_animate: 8.8158158158,
  },
  {
    x: 2.8828828829,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.7387387387,
    line4: 0.3753753754,
    line5: 92.8198198107,
    line6: 0.5511633443,
    line_animate: 8.4954954955,
  },
  {
    x: 2.8878878879,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.6786786787,
    line4: 0.4020687354,
    line5: 88.8958958872,
    line6: 0.5687191844,
    line_animate: 8.1751751752,
  },
  {
    x: 2.8928928929,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.6186186186,
    line4: 0.4287620954,
    line5: 84.9719719636,
    line6: 0.5865150799,
    line_animate: 7.8548548548,
  },
  {
    x: 2.8978978979,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.5585585586,
    line4: 0.4554554555,
    line5: 81.0480480401,
    line6: 0.6043310651,
    line_animate: 7.5345345345,
  },
  {
    x: 2.9029029029,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.4984984985,
    line4: 0.4821488155,
    line5: 77.1241241166,
    line6: 0.6221470504,
    line_animate: 7.2142142142,
  },
  {
    x: 2.9079079079,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.4384384384,
    line4: 0.5088421755,
    line5: 73.200200193,
    line6: 0.6399827971,
    line_animate: 6.8938938939,
  },
  {
    x: 2.9129129129,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.3783783784,
    line4: 0.5355355355,
    line5: 69.2762762695,
    line6: 0.6581683591,
    line_animate: 6.5735735736,
  },
  {
    x: 2.9179179179,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.3183183183,
    line4: 0.5622288956,
    line5: 65.352352346,
    line6: 0.676596455,
    line_animate: 6.2532532532,
  },
  {
    x: 2.9229229229,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.2582582583,
    line4: 0.5889222556,
    line5: 61.4284284224,
    line6: 0.6952760649,
    line_animate: 5.9329329329,
  },
  {
    x: 2.9279279279,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.1981981982,
    line4: 0.6156156156,
    line5: 57.5045044989,
    line6: 0.7140574891,
    line_animate: 5.6126126126,
  },
  {
    x: 2.9329329329,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.1381381381,
    line4: 0.6423089756,
    line5: 53.5805805754,
    line6: 0.7329749561,
    line_animate: 5.2922922923,
  },
  {
    x: 2.9379379379,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.0780780781,
    line4: 0.6690023357,
    line5: 49.6566566518,
    line6: 0.7519496937,
    line_animate: 4.971971972,
  },
  {
    x: 2.9429429429,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -1.018018018,
    line4: 0.6956956957,
    line5: 45.7327327283,
    line6: 0.7710200164,
    line_animate: 4.6516516516,
  },
  {
    x: 2.9479479479,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.957957958,
    line4: 0.7223890557,
    line5: 41.8088088048,
    line6: 0.790188222,
    line_animate: 4.3313313313,
  },
  {
    x: 2.952952953,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.8978978979,
    line4: 0.7490824157,
    line5: 37.8848848812,
    line6: 0.8094168172,
    line_animate: 4.011011011,
  },
  {
    x: 2.957957958,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.8378378378,
    line4: 0.7757757758,
    line5: 33.9609609577,
    line6: 0.8287786432,
    line_animate: 3.6906906907,
  },
  {
    x: 2.962962963,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.7777777778,
    line4: 0.8024691358,
    line5: 30.0370370342,
    line6: 0.848290384,
    line_animate: 3.3703703704,
  },
  {
    x: 2.967967968,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.7177177177,
    line4: 0.8291624958,
    line5: 26.1131131106,
    line6: 0.8681360241,
    line_animate: 3.05005005,
  },
  {
    x: 2.972972973,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.6576576577,
    line4: 0.8558558559,
    line5: 22.1891891871,
    line6: 0.8882730292,
    line_animate: 2.7297297297,
  },
  {
    x: 2.977977978,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.5975975976,
    line4: 0.8825492159,
    line5: 18.2652652636,
    line6: 0.90850154,
    line_animate: 2.4094094094,
  },
  {
    x: 2.982982983,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.5375375375,
    line4: 0.9092425759,
    line5: 14.34134134,
    line6: 0.9290264956,
    line_animate: 2.0890890891,
  },
  {
    x: 2.987987988,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.4774774775,
    line4: 0.9359359359,
    line5: 10.4174174165,
    line6: 0.9497312441,
    line_animate: 1.7687687688,
  },
  {
    x: 2.992992993,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.4174174174,
    line4: 0.962629296,
    line5: 6.493493493,
    line6: 0.9705555644,
    line_animate: 1.4484484484,
  },
  {
    x: 2.997997998,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.3573573574,
    line4: 0.989322656,
    line5: 2.5695695694,
    line6: 0.9915570299,
    line_animate: 1.1281281281,
  },
  {
    x: 3.003003003,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.2972972973,
    line4: 1.016016016,
    line5: -1.3543543541,
    line6: 1.0127609804,
    line_animate: 0.8078078078,
  },
  {
    x: 3.008008008,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.2372372372,
    line4: 1.042709376,
    line5: -5.2782782776,
    line6: 1.03406274,
    line_animate: 0.4874874875,
  },
  {
    x: 3.013013013,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.1771771772,
    line4: 1.0694027361,
    line5: -9.2022022012,
    line6: 1.0553644995,
    line_animate: 0.1671671672,
  },
  {
    x: 3.018018018,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.1171171171,
    line4: 1.0960960961,
    line5: -13.1261261247,
    line6: 1.0768832723,
    line_animate: -0.1531531532,
  },
  {
    x: 3.023023023,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: -0.0570570571,
    line4: 1.1227894561,
    line5: -17.0500500482,
    line6: 1.0985756884,
    line_animate: -0.4734734735,
  },
  {
    x: 3.028028028,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.003003003,
    line4: 1.1494828161,
    line5: -20.9739739718,
    line6: 1.1202681044,
    line_animate: -0.7937937938,
  },
  {
    x: 3.033033033,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.0630630631,
    line4: 1.1761761762,
    line5: -24.8978978953,
    line6: 1.1420349921,
    line_animate: -1.1141141141,
  },
  {
    x: 3.038038038,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.1231231231,
    line4: 1.2028695362,
    line5: -28.8218218189,
    line6: 1.1640307072,
    line_animate: -1.4344344344,
  },
  {
    x: 3.043043043,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.1831831832,
    line4: 1.2295628962,
    line5: -32.7457457424,
    line6: 1.1861162096,
    line_animate: -1.7547547548,
  },
  {
    x: 3.048048048,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.2432432432,
    line4: 1.2562562563,
    line5: -36.6696696659,
    line6: 1.208360483,
    line_animate: -2.0750750751,
  },
  {
    x: 3.0530530531,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.3033033033,
    line4: 1.2829496163,
    line5: -40.5935935895,
    line6: 1.2309428074,
    line_animate: -2.3953953954,
  },
  {
    x: 3.0580580581,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.3633633634,
    line4: 1.3096429763,
    line5: -44.517517513,
    line6: 1.2537664317,
    line_animate: -2.7157157157,
  },
  {
    x: 3.0630630631,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.4234234234,
    line4: 1.3363363363,
    line5: -48.4414414365,
    line6: 1.2766424296,
    line_animate: -3.036036036,
  },
  {
    x: 3.0680680681,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.4834834835,
    line4: 1.3630296964,
    line5: -52.3653653601,
    line6: 1.2997050635,
    line_animate: -3.3563563564,
  },
  {
    x: 3.0730730731,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.5435435435,
    line4: 1.3897230564,
    line5: -56.2892892836,
    line6: 1.3228027268,
    line_animate: -3.6766766767,
  },
  {
    x: 3.0780780781,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.6036036036,
    line4: 1.4164164164,
    line5: -60.2132132071,
    line6: 1.3460764981,
    line_animate: -3.996996997,
  },
  {
    x: 3.0830830831,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.6636636637,
    line4: 1.4431097764,
    line5: -64.1371371307,
    line6: 1.369494164,
    line_animate: -4.3173173173,
  },
  {
    x: 3.0880880881,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.7237237237,
    line4: 1.4698031365,
    line5: -68.0610610542,
    line6: 1.3930704047,
    line_animate: -4.6376376376,
  },
  {
    x: 3.0930930931,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.7837837838,
    line4: 1.4964964965,
    line5: -71.9849849777,
    line6: 1.4169441651,
    line_animate: -4.957957958,
  },
  {
    x: 3.0980980981,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.8438438438,
    line4: 1.5231898565,
    line5: -75.9089089013,
    line6: 1.4410442988,
    line_animate: -5.2782782783,
  },
  {
    x: 3.1031031031,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.9039039039,
    line4: 1.5498832165,
    line5: -79.8328328248,
    line6: 1.4658790839,
    line_animate: -5.5985985986,
  },
  {
    x: 3.1081081081,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 0.963963964,
    line4: 1.5765765766,
    line5: -83.7567567483,
    line6: 1.4909584187,
    line_animate: -5.9189189189,
  },
  {
    x: 3.1131131131,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.024024024,
    line4: 1.6032699366,
    line5: -87.6806806719,
    line6: 1.5160918058,
    line_animate: -6.2392392392,
  },
  {
    x: 3.1181181181,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.0840840841,
    line4: 1.6299632966,
    line5: -91.6046045954,
    line6: 1.5413729883,
    line_animate: -6.5595595596,
  },
  {
    x: 3.1231231231,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.1441441441,
    line4: 1.6566566567,
    line5: -95.5285285189,
    line6: 1.5668742238,
    line_animate: -6.8798798799,
  },
  {
    x: 3.1281281281,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.2042042042,
    line4: 1.6833500167,
    line5: -99.4524524425,
    line6: 1.5928828731,
    line_animate: -7.2002002002,
  },
  {
    x: 3.1331331331,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.2642642643,
    line4: 1.7100433767,
    line5: -103.376376366,
    line6: 1.6189742827,
    line_animate: -7.5205205205,
  },
  {
    x: 3.1381381381,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.3243243243,
    line4: 1.7367367367,
    line5: -107.3003002895,
    line6: 1.6450656923,
    line_animate: -7.8408408408,
  },
  {
    x: 3.1431431431,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.3843843844,
    line4: 1.7634300968,
    line5: -111.2242242131,
    line6: 1.6711571018,
    line_animate: -8.1611611612,
  },
  {
    x: 3.1481481481,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.4444444444,
    line4: 1.7901234568,
    line5: -115.1481481366,
    line6: 1.6973156829,
    line_animate: -8.4814814815,
  },
  {
    x: 3.1531531532,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.5045045045,
    line4: 1.8168168168,
    line5: -119.0720720601,
    line6: 1.7236112854,
    line_animate: -8.8018018018,
  },
  {
    x: 3.1581581582,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.5645645646,
    line4: 1.8435101768,
    line5: -122.9959959837,
    line6: 1.749906888,
    line_animate: -9.1221221221,
  },
  {
    x: 3.1631631632,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.6246246246,
    line4: 1.8702035369,
    line5: -126.9199199072,
    line6: 1.7762024905,
    line_animate: -9.4424424424,
  },
  {
    x: 3.1681681682,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.6846846847,
    line4: 1.8968968969,
    line5: -130.8438438307,
    line6: 1.802591,
    line_animate: -9.7627627628,
  },
  {
    x: 3.1731731732,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.7447447447,
    line4: 1.9235902569,
    line5: -134.7677677543,
    line6: 1.829297762,
    line_animate: -10.0830830831,
  },
  {
    x: 3.1781781782,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.8048048048,
    line4: 1.950283617,
    line5: -138.6916916778,
    line6: 1.8560045241,
    line_animate: -10.4034034034,
  },
  {
    x: 3.1831831832,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.8648648649,
    line4: 1.976976977,
    line5: -142.6156156013,
    line6: 1.8829101501,
    line_animate: -10.7237237237,
  },
  {
    x: 3.1881881882,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.9249249249,
    line4: 2.003670337,
    line5: -146.5395395249,
    line6: 1.9098232566,
    line_animate: -11.044044044,
  },
  {
    x: 3.1931931932,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 1.984984985,
    line4: 2.030363697,
    line5: -150.4634634484,
    line6: 1.9370495307,
    line_animate: -11.3643643644,
  },
  {
    x: 3.1981981982,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.045045045,
    line4: 2.0570570571,
    line5: -154.3873873719,
    line6: 1.9643768184,
    line_animate: -11.6846846847,
  },
  {
    x: 3.2032032032,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.1051051051,
    line4: 2.0837504171,
    line5: -158.3113112955,
    line6: 1.991704106,
    line_animate: -12.005005005,
  },
  {
    x: 3.2082082082,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.1651651652,
    line4: 2.1104437771,
    line5: -162.235235219,
    line6: 2.0190828904,
    line_animate: -12.3253253253,
  },
  {
    x: 3.2132132132,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.2252252252,
    line4: 2.1371371371,
    line5: -166.1591591426,
    line6: 2.0471167347,
    line_animate: -12.6456456456,
  },
  {
    x: 3.2182182182,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.2852852853,
    line4: 2.1638304972,
    line5: -170.0830830661,
    line6: 2.0752775854,
    line_animate: -12.965965966,
  },
  {
    x: 3.2232232232,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.3453453453,
    line4: 2.1905238572,
    line5: -174.0070069896,
    line6: 2.1035010497,
    line_animate: -13.2862862863,
  },
  {
    x: 3.2282282282,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.4054054054,
    line4: 2.2172172172,
    line5: -177.9309309132,
    line6: 2.1318711734,
    line_animate: -13.6066066066,
  },
  {
    x: 3.2332332332,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.4654654655,
    line4: 2.2439105772,
    line5: -181.8548548367,
    line6: 2.1602412972,
    line_animate: -13.9269269269,
  },
  {
    x: 3.2382382382,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.5255255255,
    line4: 2.2706039373,
    line5: -185.7787787602,
    line6: 2.1886114209,
    line_animate: -14.2472472472,
  },
  {
    x: 3.2432432432,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.5855855856,
    line4: 2.2972972973,
    line5: -189.7027026838,
    line6: 2.2169815446,
    line_animate: -14.5675675676,
  },
  {
    x: 3.2482482482,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.6456456456,
    line4: 2.3239906573,
    line5: -193.6266266073,
    line6: 2.2455342119,
    line_animate: -14.8878878879,
  },
  {
    x: 3.2532532533,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.7057057057,
    line4: 2.3506840174,
    line5: -197.5505505308,
    line6: 2.2741151071,
    line_animate: -15.2082082082,
  },
  {
    x: 3.2582582583,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.7657657658,
    line4: 2.3773773774,
    line5: -201.4744744544,
    line6: 2.302848492,
    line_animate: -15.5285285285,
  },
  {
    x: 3.2632632633,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.8258258258,
    line4: 2.4040707374,
    line5: -205.3983983779,
    line6: 2.3316408837,
    line_animate: -15.8488488488,
  },
  {
    x: 3.2682682683,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.8858858859,
    line4: 2.4307640974,
    line5: -209.3223223014,
    line6: 2.3605653985,
    line_animate: -16.1691691692,
  },
  {
    x: 3.2732732733,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 2.9459459459,
    line4: 2.4574574575,
    line5: -213.246246225,
    line6: 2.3897389586,
    line_animate: -16.4894894895,
  },
  {
    x: 3.2782782783,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.006006006,
    line4: 2.4841508175,
    line5: -217.1701701485,
    line6: 2.4189903217,
    line_animate: -16.8098098098,
  },
  {
    x: 3.2832832833,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.0660660661,
    line4: 2.5108441775,
    line5: -221.094094072,
    line6: 2.4484204424,
    line_animate: -17.1301301301,
  },
  {
    x: 3.2882882883,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.1261261261,
    line4: 2.5375375375,
    line5: -225.0180179956,
    line6: 2.4778505631,
    line_animate: -17.4504504504,
  },
  {
    x: 3.2932932933,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.1861861862,
    line4: 2.5642308976,
    line5: -228.9419419191,
    line6: 2.5074030557,
    line_animate: -17.7707707708,
  },
  {
    x: 3.2982982983,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.2462462462,
    line4: 2.5909242576,
    line5: -232.8658658426,
    line6: 2.5370470892,
    line_animate: -18.0910910911,
  },
  {
    x: 3.3033033033,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.3063063063,
    line4: 2.6176176176,
    line5: -236.7897897662,
    line6: 2.5666911228,
    line_animate: -18.4114114114,
  },
  {
    x: 3.3083083083,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.3663663664,
    line4: 2.6443109776,
    line5: -240.7137136897,
    line6: 2.5966822352,
    line_animate: -18.7317317317,
  },
  {
    x: 3.3133133133,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.4264264264,
    line4: 2.6710043377,
    line5: -244.6376376132,
    line6: 2.6267559631,
    line_animate: -19.052052052,
  },
  {
    x: 3.3183183183,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.4864864865,
    line4: 2.6976976977,
    line5: -248.5615615368,
    line6: 2.6570273005,
    line_animate: -19.3723723724,
  },
  {
    x: 3.3233233233,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.5465465465,
    line4: 2.7243910577,
    line5: -252.4854854603,
    line6: 2.6873165147,
    line_animate: -19.6926926927,
  },
  {
    x: 3.3283283283,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.6066066066,
    line4: 2.7510844178,
    line5: -256.4094093838,
    line6: 2.7177424766,
    line_animate: -20.013013013,
  },
  {
    x: 3.3333333333,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.6666666667,
    line4: 2.7777777778,
    line5: -260.3333333074,
    line6: 2.7482479493,
    line_animate: -20.3333333333,
  },
  {
    x: 3.3383383383,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.7267267267,
    line4: 2.8044711378,
    line5: -264.2572572309,
    line6: 2.778753422,
    line_animate: -20.6536536536,
  },
  {
    x: 3.3433433433,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.7867867868,
    line4: 2.8311644978,
    line5: -268.1811811544,
    line6: 2.8093610071,
    line_animate: -20.973973974,
  },
  {
    x: 3.3483483483,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.8468468468,
    line4: 2.8578578579,
    line5: -272.105105078,
    line6: 2.8405870002,
    line_animate: -21.2942942943,
  },
  {
    x: 3.3533533534,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.9069069069,
    line4: 2.8845512179,
    line5: -276.0290290015,
    line6: 2.8721570867,
    line_animate: -21.6146146146,
  },
  {
    x: 3.3583583584,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 3.966966967,
    line4: 2.9112445779,
    line5: -279.952952925,
    line6: 2.90400812,
    line_animate: -21.9349349349,
  },
  {
    x: 3.3633633634,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.027027027,
    line4: 2.9379379379,
    line5: -283.8768768486,
    line6: 2.936038073,
    line_animate: -22.2552552552,
  },
  {
    x: 3.3683683684,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.0870870871,
    line4: 2.964631298,
    line5: -287.8008007721,
    line6: 2.9680680259,
    line_animate: -22.5755755756,
  },
  {
    x: 3.3733733734,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.1471471471,
    line4: 2.991324658,
    line5: -291.7247246956,
    line6: 3.0000979788,
    line_animate: -22.8958958959,
  },
  {
    x: 3.3783783784,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.2072072072,
    line4: 3.018018018,
    line5: -295.6486486192,
    line6: 3.0322849392,
    line_animate: -23.2162162162,
  },
  {
    x: 3.3833833834,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.2672672673,
    line4: 3.044711378,
    line5: -299.5725725427,
    line6: 3.0649371443,
    line_animate: -23.5365365365,
  },
  {
    x: 3.3883883884,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.3273273273,
    line4: 3.0714047381,
    line5: -303.4964964663,
    line6: 3.0977498547,
    line_animate: -23.8568568568,
  },
  {
    x: 3.3933933934,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.3873873874,
    line4: 3.0980980981,
    line5: -307.4204203898,
    line6: 3.1307918966,
    line_animate: -24.1771771772,
  },
  {
    x: 3.3983983984,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.4474474474,
    line4: 3.1247914581,
    line5: -311.3443443133,
    line6: 3.1640852466,
    line_animate: -24.4974974975,
  },
  {
    x: 3.4034034034,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.5075075075,
    line4: 3.1514848182,
    line5: -315.2682682369,
    line6: 3.1974365291,
    line_animate: -24.8178178178,
  },
  {
    x: 3.4084084084,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.5675675676,
    line4: 3.1781781782,
    line5: -319.1921921604,
    line6: 3.2307878115,
    line_animate: -25.1381381381,
  },
  {
    x: 3.4134134134,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.6276276276,
    line4: 3.2048715382,
    line5: -323.1161160839,
    line6: 3.264139094,
    line_animate: -25.4584584584,
  },
  {
    x: 3.4184184184,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.6876876877,
    line4: 3.2315648982,
    line5: -327.0400400075,
    line6: 3.298041155,
    line_animate: -25.7787787788,
  },
  {
    x: 3.4234234234,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.7477477477,
    line4: 3.2582582583,
    line5: -330.963963931,
    line6: 3.3321821539,
    line_animate: -26.0990990991,
  },
  {
    x: 3.4284284284,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.8078078078,
    line4: 3.2849516183,
    line5: -334.8878878545,
    line6: 3.3667422031,
    line_animate: -26.4194194194,
  },
  {
    x: 3.4334334334,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.8678678679,
    line4: 3.3116449783,
    line5: -338.8118117781,
    line6: 3.4014290052,
    line_animate: -26.7397397397,
  },
  {
    x: 3.4384384384,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.9279279279,
    line4: 3.3383383383,
    line5: -342.7357357016,
    line6: 3.4361158073,
    line_animate: -27.06006006,
  },
  {
    x: 3.4434434434,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 4.987987988,
    line4: 3.3650316984,
    line5: -346.6596596251,
    line6: 3.4708140567,
    line_animate: -27.3803803804,
  },
  {
    x: 3.4484484484,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.048048048,
    line4: 3.3917250584,
    line5: -350.5835835487,
    line6: 3.5057250879,
    line_animate: -27.7007007007,
  },
  {
    x: 3.4534534535,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.1081081081,
    line4: 3.4184184184,
    line5: -354.5075074722,
    line6: 3.5407334543,
    line_animate: -28.021021021,
  },
  {
    x: 3.4584584585,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.1681681682,
    line4: 3.4451117784,
    line5: -358.4314313957,
    line6: 3.5760076697,
    line_animate: -28.3413413413,
  },
  {
    x: 3.4634634635,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.2282282282,
    line4: 3.4718051385,
    line5: -362.3553553193,
    line6: 3.6113685292,
    line_animate: -28.6616616616,
  },
  {
    x: 3.4684684685,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.2882882883,
    line4: 3.4984984985,
    line5: -366.2792792428,
    line6: 3.6468365873,
    line_animate: -28.981981982,
  },
  {
    x: 3.4734734735,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.3483483483,
    line4: 3.5251918585,
    line5: -370.2032031663,
    line6: 3.6830564046,
    line_animate: -29.3023023023,
  },
  {
    x: 3.4784784785,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.4084084084,
    line4: 3.5518852186,
    line5: -374.1271270899,
    line6: 3.7193209157,
    line_animate: -29.6226226226,
  },
  {
    x: 3.4834834835,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.4684684685,
    line4: 3.5785785786,
    line5: -378.0510510134,
    line6: 3.7556383826,
    line_animate: -29.9429429429,
  },
  {
    x: 3.4884884885,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.5285285285,
    line4: 3.6052719386,
    line5: -381.9749749369,
    line6: 3.792394159,
    line_animate: -30.2632632632,
  },
  {
    x: 3.4934934935,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.5885885886,
    line4: 3.6319652986,
    line5: -385.8988988605,
    line6: 3.8297933256,
    line_animate: -30.5835835836,
  },
  {
    x: 3.4984984985,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.6486486486,
    line4: 3.6586586587,
    line5: -389.822822784,
    line6: 3.8677467688,
    line_animate: -30.9039039039,
  },
  {
    x: 3.5035035035,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.7087087087,
    line4: 3.6853520187,
    line5: -393.7467467075,
    line6: 3.9059619265,
    line_animate: -31.2242242242,
  },
  {
    x: 3.5085085085,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.7687687688,
    line4: 3.7120453787,
    line5: -397.6706706311,
    line6: 3.944385874,
    line_animate: -31.5445445445,
  },
  {
    x: 3.5135135135,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.8288288288,
    line4: 3.7387387387,
    line5: -401.5945945546,
    line6: 3.9831906885,
    line_animate: -31.8648648648,
  },
  {
    x: 3.5185185185,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.8888888889,
    line4: 3.7654320988,
    line5: -405.5185184781,
    line6: 4.0221880494,
    line_animate: -32.1851851852,
  },
  {
    x: 3.5235235235,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 5.9489489489,
    line4: 3.7921254588,
    line5: -409.4424424017,
    line6: 4.0611854104,
    line_animate: -32.5055055055,
  },
  {
    x: 3.5285285285,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.009009009,
    line4: 3.8188188188,
    line5: -413.3663663252,
    line6: 4.1001827713,
    line_animate: -32.8258258258,
  },
  {
    x: 3.5335335335,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.0690690691,
    line4: 3.8455121788,
    line5: -417.2902902487,
    line6: 4.1391801323,
    line_animate: -33.1461461461,
  },
  {
    x: 3.5385385385,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.1291291291,
    line4: 3.8722055389,
    line5: -421.2142141723,
    line6: 4.178536511,
    line_animate: -33.4664664664,
  },
  {
    x: 3.5435435435,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.1891891892,
    line4: 3.8988988989,
    line5: -425.1381380958,
    line6: 4.2181794673,
    line_animate: -33.7867867868,
  },
  {
    x: 3.5485485485,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.2492492492,
    line4: 3.9255922589,
    line5: -429.0620620193,
    line6: 4.2579361837,
    line_animate: -34.1071071071,
  },
  {
    x: 3.5535535536,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.3093093093,
    line4: 3.952285619,
    line5: -432.9859859429,
    line6: 4.2982073717,
    line_animate: -34.4274274274,
  },
  {
    x: 3.5585585586,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.3693693694,
    line4: 3.978978979,
    line5: -436.9099098664,
    line6: 4.3388993274,
    line_animate: -34.7477477477,
  },
  {
    x: 3.5635635636,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.4294294294,
    line4: 4.005672339,
    line5: -440.83383379,
    line6: 4.3799055337,
    line_animate: -35.068068068,
  },
  {
    x: 3.5685685686,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.4894894895,
    line4: 4.032365699,
    line5: -444.7577577135,
    line6: 4.4211158012,
    line_animate: -35.3883883884,
  },
  {
    x: 3.5735735736,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.5495495495,
    line4: 4.0590590591,
    line5: -448.681681637,
    line6: 4.4624386599,
    line_animate: -35.7087087087,
  },
  {
    x: 3.5785785786,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.6096096096,
    line4: 4.0857524191,
    line5: -452.6056055606,
    line6: 4.5040842874,
    line_animate: -36.029029029,
  },
  {
    x: 3.5835835836,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.6696696697,
    line4: 4.1124457791,
    line5: -456.5295294841,
    line6: 4.5458617552,
    line_animate: -36.3493493493,
  },
  {
    x: 3.5885885886,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.7297297297,
    line4: 4.1391391391,
    line5: -460.4534534076,
    line6: 4.587685322,
    line_animate: -36.6696696696,
  },
  {
    x: 3.5935935936,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.7897897898,
    line4: 4.1658324992,
    line5: -464.3773773312,
    line6: 4.6301360801,
    line_animate: -36.98998999,
  },
  {
    x: 3.5985985986,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.8498498498,
    line4: 4.1925258592,
    line5: -468.3013012547,
    line6: 4.6729662794,
    line_animate: -37.3103103103,
  },
  {
    x: 3.6036036036,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.9099099099,
    line4: 4.2192192192,
    line5: -472.2252251782,
    line6: 4.7159148107,
    line_animate: -37.6306306306,
  },
  {
    x: 3.6086086086,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 6.96996997,
    line4: 4.2459125792,
    line5: -476.1491491018,
    line6: 4.7591116533,
    line_animate: -37.9509509509,
  },
  {
    x: 3.6136136136,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.03003003,
    line4: 4.2726059393,
    line5: -480.0730730253,
    line6: 4.8026370268,
    line_animate: -38.2712712712,
  },
  {
    x: 3.6186186186,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.0900900901,
    line4: 4.2992992993,
    line5: -483.9969969488,
    line6: 4.8468896445,
    line_animate: -38.5915915916,
  },
  {
    x: 3.6236236236,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.1501501502,
    line4: 4.3259926593,
    line5: -487.9209208724,
    line6: 4.8916867001,
    line_animate: -38.9119119119,
  },
  {
    x: 3.6286286286,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.2102102102,
    line4: 4.3526860194,
    line5: -491.8448447959,
    line6: 4.9369763206,
    line_animate: -39.2322322322,
  },
  {
    x: 3.6336336336,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.2702702703,
    line4: 4.3793793794,
    line5: -495.7687687194,
    line6: 4.9828744876,
    line_animate: -39.5525525525,
  },
  {
    x: 3.6386386386,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.3303303303,
    line4: 4.4060727394,
    line5: -499.692692643,
    line6: 5.0290177669,
    line_animate: -39.8728728728,
  },
  {
    x: 3.6436436436,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.3903903904,
    line4: 4.4327660994,
    line5: -503.6166165665,
    line6: 5.0753131591,
    line_animate: -40.1931931932,
  },
  {
    x: 3.6486486486,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.4504504505,
    line4: 4.4594594595,
    line5: -507.54054049,
    line6: 5.1219131921,
    line_animate: -40.5135135135,
  },
  {
    x: 3.6536536537,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.5105105105,
    line4: 4.4861528195,
    line5: -511.4644644136,
    line6: 5.168643521,
    line_animate: -40.8338338338,
  },
  {
    x: 3.6586586587,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.5705705706,
    line4: 4.5128461795,
    line5: -515.3883883371,
    line6: 5.21537385,
    line_animate: -41.1541541541,
  },
  {
    x: 3.6636636637,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.6306306306,
    line4: 4.5395395395,
    line5: -519.3123122606,
    line6: 5.2621041789,
    line_animate: -41.4744744744,
  },
  {
    x: 3.6686686687,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.6906906907,
    line4: 4.5662328996,
    line5: -523.2362361842,
    line6: 5.3088345079,
    line_animate: -41.7947947948,
  },
  {
    x: 3.6736736737,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.7507507508,
    line4: 4.5929262596,
    line5: -527.1601601077,
    line6: 5.3556568182,
    line_animate: -42.1151151151,
  },
  {
    x: 3.6786786787,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.8108108108,
    line4: 4.6196196196,
    line5: -531.0840840312,
    line6: 5.4026268118,
    line_animate: -42.4354354354,
  },
  {
    x: 3.6836836837,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.8708708709,
    line4: 4.6463129796,
    line5: -535.0080079548,
    line6: 5.4498708404,
    line_animate: -42.7557557557,
  },
  {
    x: 3.6886886887,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.9309309309,
    line4: 4.6730063397,
    line5: -538.9319318783,
    line6: 5.4973213894,
    line_animate: -43.076076076,
  },
  {
    x: 3.6936936937,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 7.990990991,
    line4: 4.6996996997,
    line5: -542.8558558018,
    line6: 5.5449361577,
    line_animate: -43.3963963964,
  },
  {
    x: 3.6986986987,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.0510510511,
    line4: 4.7263930597,
    line5: -546.7797797254,
    line6: 5.592868769,
    line_animate: -43.7167167167,
  },
  {
    x: 3.7037037037,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.1111111111,
    line4: 4.7530864198,
    line5: -550.7037036489,
    line6: 5.6409092315,
    line_animate: -44.037037037,
  },
  {
    x: 3.7087087087,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.1711711712,
    line4: 4.7797797798,
    line5: -554.6276275724,
    line6: 5.6892721628,
    line_animate: -44.3573573573,
  },
  {
    x: 3.7137137137,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.2312312312,
    line4: 4.8064731398,
    line5: -558.551551496,
    line6: 5.7380470096,
    line_animate: -44.6776776776,
  },
  {
    x: 3.7187187187,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.2912912913,
    line4: 4.8331664998,
    line5: -562.4754754195,
    line6: 5.7871901842,
    line_animate: -44.997997998,
  },
  {
    x: 3.7237237237,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.3513513514,
    line4: 4.8598598599,
    line5: -566.399399343,
    line6: 5.8367681284,
    line_animate: -45.3183183183,
  },
  {
    x: 3.7287287287,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.4114114114,
    line4: 4.8865532199,
    line5: -570.3233232666,
    line6: 5.8868833958,
    line_animate: -45.6386386386,
  },
  {
    x: 3.7337337337,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.4714714715,
    line4: 4.9132465799,
    line5: -574.2472471901,
    line6: 5.9371435494,
    line_animate: -45.9589589589,
  },
  {
    x: 3.7387387387,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.5315315315,
    line4: 4.9399399399,
    line5: -578.1711711136,
    line6: 5.9877463168,
    line_animate: -46.2792792792,
  },
  {
    x: 3.7437437437,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.5915915916,
    line4: 4.9666333,
    line5: -582.0950950372,
    line6: 6.0388517829,
    line_animate: -46.5995995996,
  },
  {
    x: 3.7487487487,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.6516516517,
    line4: 4.99332666,
    line5: -586.0190189607,
    line6: 6.0901920691,
    line_animate: -46.9199199199,
  },
  {
    x: 3.7537537538,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.7117117117,
    line4: 5.0600600601,
    line5: -578.0510509935,
    line6: 6.1417725782,
    line_animate: -46.1591591591,
  },
  {
    x: 3.7587587588,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.7717717718,
    line4: 5.1401401401,
    line5: -566.1191190628,
    line6: 6.193891895,
    line_animate: -45.038038038,
  },
  {
    x: 3.7637637638,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.8318318318,
    line4: 5.2202202202,
    line5: -554.187187132,
    line6: 6.2462082828,
    line_animate: -43.9169169169,
  },
  {
    x: 3.7687687688,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.8918918919,
    line4: 5.3003003003,
    line5: -542.2552552012,
    line6: 6.2987559824,
    line_animate: -42.7957957957,
  },
  {
    x: 3.7737737738,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 8.951951952,
    line4: 5.3803803804,
    line5: -530.3233232705,
    line6: 6.3515542249,
    line_animate: -41.6746746746,
  },
  {
    x: 3.7787787788,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.012012012,
    line4: 5.4604604605,
    line5: -518.3913913397,
    line6: 6.4050833445,
    line_animate: -40.5535535535,
  },
  {
    x: 3.7837837838,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.0720720721,
    line4: 5.5405405405,
    line5: -506.459459409,
    line6: 6.4588784436,
    line_animate: -39.4324324324,
  },
  {
    x: 3.7887887888,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.1321321321,
    line4: 5.6206206206,
    line5: -494.5275274782,
    line6: 6.5127985497,
    line_animate: -38.3113113113,
  },
  {
    x: 3.7937937938,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.1921921922,
    line4: 5.7007007007,
    line5: -482.5955955474,
    line6: 6.5670246608,
    line_animate: -37.1901901901,
  },
  {
    x: 3.7987987988,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.2522522523,
    line4: 5.7807807808,
    line5: -470.6636636167,
    line6: 6.621323752,
    line_animate: -36.069069069,
  },
  {
    x: 3.8038038038,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.3123123123,
    line4: 5.8608608609,
    line5: -458.7317316859,
    line6: 6.6758621369,
    line_animate: -34.9479479479,
  },
  {
    x: 3.8088088088,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.3723723724,
    line4: 5.9409409409,
    line5: -446.7997997551,
    line6: 6.7306499233,
    line_animate: -33.8268268268,
  },
  {
    x: 3.8138138138,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.4324324324,
    line4: 6.021021021,
    line5: -434.8678678244,
    line6: 6.7856858102,
    line_animate: -32.7057057057,
  },
  {
    x: 3.8188188188,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.4924924925,
    line4: 6.1011011011,
    line5: -422.9359358936,
    line6: 6.840721697,
    line_animate: -31.5845845845,
  },
  {
    x: 3.8238238238,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.5525525526,
    line4: 6.1811811812,
    line5: -411.0040039629,
    line6: 6.8959463492,
    line_animate: -30.4634634634,
  },
  {
    x: 3.8288288288,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.6126126126,
    line4: 6.2612612613,
    line5: -399.0720720321,
    line6: 6.951231915,
    line_animate: -29.3423423423,
  },
  {
    x: 3.8338338338,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.6726726727,
    line4: 6.3413413413,
    line5: -387.1401401013,
    line6: 7.0065249596,
    line_animate: -28.2212212212,
  },
  {
    x: 3.8388388388,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.7327327327,
    line4: 6.4214214214,
    line5: -375.2082081706,
    line6: 7.0622420176,
    line_animate: -27.1001001001,
  },
  {
    x: 3.8438438438,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.7927927928,
    line4: 6.5015015015,
    line5: -363.2762762398,
    line6: 7.1180288884,
    line_animate: -25.9789789789,
  },
  {
    x: 3.8488488488,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.8528528529,
    line4: 6.5815815816,
    line5: -351.344344309,
    line6: 7.1739736553,
    line_animate: -24.8578578578,
  },
  {
    x: 3.8538538539,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.9129129129,
    line4: 6.6616616617,
    line5: -339.4124123783,
    line6: 7.2304097007,
    line_animate: -23.7367367367,
  },
  {
    x: 3.8588588589,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 9.972972973,
    line4: 6.7417417417,
    line5: -327.4804804475,
    line6: 7.287203337,
    line_animate: -22.6156156156,
  },
  {
    x: 3.8638638639,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.033033033,
    line4: 6.8218218218,
    line5: -315.5485485168,
    line6: 7.3441432214,
    line_animate: -21.4944944945,
  },
  {
    x: 3.8688688689,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.0930930931,
    line4: 6.9019019019,
    line5: -303.616616586,
    line6: 7.4016114289,
    line_animate: -20.3733733733,
  },
  {
    x: 3.8738738739,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.1531531532,
    line4: 6.981981982,
    line5: -291.6846846552,
    line6: 7.4596680976,
    line_animate: -19.2522522522,
  },
  {
    x: 3.8788788789,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.2132132132,
    line4: 7.0620620621,
    line5: -279.7527527245,
    line6: 7.5180156279,
    line_animate: -18.1311311311,
  },
  {
    x: 3.8838838839,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.2732732733,
    line4: 7.1421421421,
    line5: -267.8208207937,
    line6: 7.5766823059,
    line_animate: -17.01001001,
  },
  {
    x: 3.8888888889,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.3333333333,
    line4: 7.2222222222,
    line5: -255.8888888629,
    line6: 7.6355004996,
    line_animate: -15.8888888889,
  },
  {
    x: 3.8938938939,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.3933933934,
    line4: 7.3023023023,
    line5: -243.9569569322,
    line6: 7.6943186933,
    line_animate: -14.7677677677,
  },
  {
    x: 3.8988988989,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.4534534535,
    line4: 7.3823823824,
    line5: -232.0250250014,
    line6: 7.753471703,
    line_animate: -13.6466466466,
  },
  {
    x: 3.9039039039,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.5135135135,
    line4: 7.4624624625,
    line5: -220.0930930706,
    line6: 7.8129263799,
    line_animate: -12.5255255255,
  },
  {
    x: 3.9089089089,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.5735735736,
    line4: 7.5425425425,
    line5: -208.1611611399,
    line6: 7.872533312,
    line_animate: -11.4044044044,
  },
  {
    x: 3.9139139139,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.6336336336,
    line4: 7.6226226226,
    line5: -196.2292292091,
    line6: 7.9324514726,
    line_animate: -10.2832832833,
  },
  {
    x: 3.9189189189,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.6936936937,
    line4: 7.7027027027,
    line5: -184.2972972784,
    line6: 7.9925811741,
    line_animate: -9.1621621621,
  },
  {
    x: 3.9239239239,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.7537537538,
    line4: 7.7827827828,
    line5: -172.3653653476,
    line6: 8.0530840409,
    line_animate: -8.041041041,
  },
  {
    x: 3.9289289289,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.8138138138,
    line4: 7.8628628629,
    line5: -160.4334334168,
    line6: 8.1138423468,
    line_animate: -6.9199199199,
  },
  {
    x: 3.9339339339,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.8738738739,
    line4: 7.9429429429,
    line5: -148.5015014861,
    line6: 8.1747064799,
    line_animate: -5.7987987988,
  },
  {
    x: 3.9389389389,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.9339339339,
    line4: 8.023023023,
    line5: -136.5695695553,
    line6: 8.2356852742,
    line_animate: -4.6776776777,
  },
  {
    x: 3.9439439439,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 10.993993994,
    line4: 8.1031031031,
    line5: -124.6376376245,
    line6: 8.2970646739,
    line_animate: -3.5565565565,
  },
  {
    x: 3.9489489489,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.0540540541,
    line4: 8.1831831832,
    line5: -112.7057056938,
    line6: 8.3586722407,
    line_animate: -2.4354354354,
  },
  {
    x: 3.953953954,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.1141141141,
    line4: 8.2632632633,
    line5: -100.773773763,
    line6: 8.4203097261,
    line_animate: -1.3143143143,
  },
  {
    x: 3.958958959,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.1741741742,
    line4: 8.3433433433,
    line5: -88.8418418323,
    line6: 8.4820703471,
    line_animate: -0.1931931932,
  },
  {
    x: 3.963963964,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.2342342342,
    line4: 8.4234234234,
    line5: -76.9099099015,
    line6: 8.5439769711,
    line_animate: 0.9279279279,
  },
  {
    x: 3.968968969,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.2942942943,
    line4: 8.5035035035,
    line5: -64.9779779707,
    line6: 8.6063686362,
    line_animate: 2.0490490491,
  },
  {
    x: 3.973973974,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.3543543544,
    line4: 8.5835835836,
    line5: -53.04604604,
    line6: 8.6691541857,
    line_animate: 3.1701701702,
  },
  {
    x: 3.978978979,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.4144144144,
    line4: 8.6636636637,
    line5: -41.1141141092,
    line6: 8.7322828966,
    line_animate: 4.2912912913,
  },
  {
    x: 3.983983984,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.4744744745,
    line4: 8.7437437437,
    line5: -29.1821821784,
    line6: 8.7957638301,
    line_animate: 5.4124124124,
  },
  {
    x: 3.988988989,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.5345345345,
    line4: 8.8238238238,
    line5: -17.2502502477,
    line6: 8.8594799879,
    line_animate: 6.5335335335,
  },
  {
    x: 3.993993994,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.5945945946,
    line4: 8.9039039039,
    line5: -5.3183183169,
    line6: 8.9232269465,
    line_animate: 7.6546546547,
  },
  {
    x: 3.998998999,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.6546546547,
    line4: 8.983983984,
    line5: 6.6136136138,
    line6: 8.9872044911,
    line_animate: 8.7757757758,
  },
  {
    x: 4.004004004,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.7147147147,
    line4: 9.0640640641,
    line5: 18.5455455446,
    line6: 9.051264457,
    line_animate: 9.8968968969,
  },
  {
    x: 4.009009009,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.7747747748,
    line4: 9.1441441441,
    line5: 30.4774774754,
    line6: 9.1158548999,
    line_animate: 11.018018018,
  },
  {
    x: 4.014014014,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.8348348348,
    line4: 9.2242242242,
    line5: 42.4094094061,
    line6: 9.1806142937,
    line_animate: 12.1391391391,
  },
  {
    x: 4.019019019,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.8948948949,
    line4: 9.3043043043,
    line5: 54.3413413369,
    line6: 9.2453736876,
    line_animate: 13.2602602603,
  },
  {
    x: 4.024024024,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 11.954954955,
    line4: 9.3843843844,
    line5: 66.2732732677,
    line6: 9.3102736428,
    line_animate: 14.3813813814,
  },
  {
    x: 4.029029029,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.015015015,
    line4: 9.4644644645,
    line5: 78.2052051984,
    line6: 9.3752891981,
    line_animate: 15.5025025025,
  },
  {
    x: 4.034034034,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.0750750751,
    line4: 9.5445445445,
    line5: 90.1371371292,
    line6: 9.4403066545,
    line_animate: 16.6236236236,
  },
  {
    x: 4.039039039,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.1351351351,
    line4: 9.6246246246,
    line5: 102.0690690599,
    line6: 9.5055749817,
    line_animate: 17.7447447447,
  },
  {
    x: 4.044044044,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.1951951952,
    line4: 9.7047047047,
    line5: 114.0010009907,
    line6: 9.5709988409,
    line_animate: 18.8658658659,
  },
  {
    x: 4.049049049,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.2552552553,
    line4: 9.7847847848,
    line5: 125.9329329215,
    line6: 9.6366107398,
    line_animate: 19.986986987,
  },
  {
    x: 4.0540540541,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.3153153153,
    line4: 9.8648648649,
    line5: 137.8648648522,
    line6: 9.7023792441,
    line_animate: 21.1081081081,
  },
  {
    x: 4.0590590591,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.3753753754,
    line4: 9.9449449449,
    line5: 149.796796783,
    line6: 9.7683187637,
    line_animate: 22.2292292292,
  },
  {
    x: 4.0640640641,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.4354354354,
    line4: 10.025025025,
    line5: 161.7287287138,
    line6: 9.8344209341,
    line_animate: 23.3503503503,
  },
  {
    x: 4.0690690691,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.4954954955,
    line4: 10.1051051051,
    line5: 173.6606606445,
    line6: 9.9011617977,
    line_animate: 24.4714714715,
  },
  {
    x: 4.0740740741,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.5555555556,
    line4: 10.1851851852,
    line5: 185.5925925753,
    line6: 9.967982895,
    line_animate: 25.5925925926,
  },
  {
    x: 4.0790790791,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.6156156156,
    line4: 10.2652652653,
    line5: 197.524524506,
    line6: 10.0349755928,
    line_animate: 26.7137137137,
  },
  {
    x: 4.0840840841,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.6756756757,
    line4: 10.3453453453,
    line5: 209.4564564368,
    line6: 10.1020144914,
    line_animate: 27.8348348348,
  },
  {
    x: 4.0890890891,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.7357357357,
    line4: 10.4254254254,
    line5: 221.3883883676,
    line6: 10.1696976552,
    line_animate: 28.9559559559,
  },
  {
    x: 4.0940940941,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.7957957958,
    line4: 10.5055055055,
    line5: 233.3203202983,
    line6: 10.2375514036,
    line_animate: 30.0770770771,
  },
  {
    x: 4.0990990991,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.8558558559,
    line4: 10.5855855856,
    line5: 245.2522522291,
    line6: 10.3055000295,
    line_animate: 31.1981981982,
  },
  {
    x: 4.1041041041,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.9159159159,
    line4: 10.6656656657,
    line5: 257.1841841599,
    line6: 10.3734486554,
    line_animate: 32.3193193193,
  },
  {
    x: 4.1091091091,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 12.975975976,
    line4: 10.7457457457,
    line5: 269.1161160906,
    line6: 10.4416078076,
    line_animate: 33.4404404404,
  },
  {
    x: 4.1141141141,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.036036036,
    line4: 10.8258258258,
    line5: 281.0480480214,
    line6: 10.5102362877,
    line_animate: 34.5615615615,
  },
  {
    x: 4.1191191191,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.0960960961,
    line4: 10.9059059059,
    line5: 292.9799799522,
    line6: 10.5788842668,
    line_animate: 35.6826826827,
  },
  {
    x: 4.1241241241,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.1561561562,
    line4: 10.985985986,
    line5: 304.9119118829,
    line6: 10.6475580751,
    line_animate: 36.8038038038,
  },
  {
    x: 4.1291291291,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.2162162162,
    line4: 11.0660660661,
    line5: 316.8438438137,
    line6: 10.7165731681,
    line_animate: 37.9249249249,
  },
  {
    x: 4.1341341341,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.2762762763,
    line4: 11.1461461461,
    line5: 328.7757757444,
    line6: 10.7856782764,
    line_animate: 39.046046046,
  },
  {
    x: 4.1391391391,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.3363363363,
    line4: 11.2262262262,
    line5: 340.7077076752,
    line6: 10.8550825855,
    line_animate: 40.1671671671,
  },
  {
    x: 4.1441441441,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.3963963964,
    line4: 11.3063063063,
    line5: 352.639639606,
    line6: 10.9246466477,
    line_animate: 41.2882882883,
  },
  {
    x: 4.1491491491,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.4564564565,
    line4: 11.3863863864,
    line5: 364.5715715367,
    line6: 10.994485683,
    line_animate: 42.4094094094,
  },
  {
    x: 4.1541541542,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.5165165165,
    line4: 11.4664664665,
    line5: 376.5035034675,
    line6: 11.0644879616,
    line_animate: 43.5305305305,
  },
  {
    x: 4.1591591592,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.5765765766,
    line4: 11.5465465465,
    line5: 388.4354353983,
    line6: 11.1344902401,
    line_animate: 44.6516516516,
  },
  {
    x: 4.1641641642,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.6366366366,
    line4: 11.6266266266,
    line5: 400.367367329,
    line6: 11.2044925186,
    line_animate: 45.7727727727,
  },
  {
    x: 4.1691691692,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.6966966967,
    line4: 11.7067067067,
    line5: 412.2992992598,
    line6: 11.2744947972,
    line_animate: 46.8938938939,
  },
  {
    x: 4.1741741742,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.7567567568,
    line4: 11.7867867868,
    line5: 424.2312311905,
    line6: 11.3446851673,
    line_animate: 48.015015015,
  },
  {
    x: 4.1791791792,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.8168168168,
    line4: 11.8668668669,
    line5: 436.1631631213,
    line6: 11.414904018,
    line_animate: 49.1361361361,
  },
  {
    x: 4.1841841842,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.8768768769,
    line4: 11.9469469469,
    line5: 448.0950950521,
    line6: 11.4851737727,
    line_animate: 50.2572572572,
  },
  {
    x: 4.1891891892,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.9369369369,
    line4: 12.027027027,
    line5: 460.0270269828,
    line6: 11.5556056881,
    line_animate: 51.3783783783,
  },
  {
    x: 4.1941941942,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 13.996996997,
    line4: 12.1071071071,
    line5: 471.9589589136,
    line6: 11.6260376036,
    line_animate: 52.4994994995,
  },
  {
    x: 4.1991991992,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.0570570571,
    line4: 12.1871871872,
    line5: 483.8908908444,
    line6: 11.6964695191,
    line_animate: 53.6206206206,
  },
  {
    x: 4.2042042042,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.1171171171,
    line4: 12.2672672673,
    line5: 495.8228227751,
    line6: 11.7669014345,
    line_animate: 54.7417417417,
  },
  {
    x: 4.2092092092,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.1771771772,
    line4: 12.3473473473,
    line5: 507.7547547059,
    line6: 11.8375090904,
    line_animate: 55.8628628628,
  },
  {
    x: 4.2142142142,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.2372372372,
    line4: 12.4274274274,
    line5: 519.6866866366,
    line6: 11.9081482139,
    line_animate: 56.9839839839,
  },
  {
    x: 4.2192192192,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.2972972973,
    line4: 12.5075075075,
    line5: 531.6186185674,
    line6: 11.9787996019,
    line_animate: 58.1051051051,
  },
  {
    x: 4.2242242242,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.3573573574,
    line4: 12.5875875876,
    line5: 543.5505504982,
    line6: 12.0498063155,
    line_animate: 59.2262262262,
  },
  {
    x: 4.2292292292,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.4174174174,
    line4: 12.6676676677,
    line5: 555.4824824289,
    line6: 12.121256234,
    line_animate: 60.3473473473,
  },
  {
    x: 4.2342342342,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.4774774775,
    line4: 12.7477477477,
    line5: 567.4144143597,
    line6: 12.1928995219,
    line_animate: 61.4684684684,
  },
  {
    x: 4.2392392392,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.5375375375,
    line4: 12.8278278278,
    line5: 579.3463462905,
    line6: 12.265296358,
    line_animate: 62.5895895895,
  },
  {
    x: 4.2442442442,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.5975975976,
    line4: 12.9079079079,
    line5: 591.2782782212,
    line6: 12.3379066388,
    line_animate: 63.7107107107,
  },
  {
    x: 4.2492492492,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.6576576577,
    line4: 12.987987988,
    line5: 603.210210152,
    line6: 12.4106659773,
    line_animate: 64.8318318318,
  },
  {
    x: 4.2542542543,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.7177177177,
    line4: 13.0680680681,
    line5: 615.1421420827,
    line6: 12.4835219901,
    line_animate: 65.9529529529,
  },
  {
    x: 4.2592592593,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.7777777778,
    line4: 13.1481481481,
    line5: 627.0740740135,
    line6: 12.5566937331,
    line_animate: 67.074074074,
  },
  {
    x: 4.2642642643,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.8378378378,
    line4: 13.2282282282,
    line5: 639.0060059443,
    line6: 12.6299600592,
    line_animate: 68.1951951951,
  },
  {
    x: 4.2692692693,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.8978978979,
    line4: 13.3083083083,
    line5: 650.937937875,
    line6: 12.7034096943,
    line_animate: 69.3163163163,
  },
  {
    x: 4.2742742743,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 14.957957958,
    line4: 13.3883883884,
    line5: 662.8698698058,
    line6: 12.7771586702,
    line_animate: 70.4374374374,
  },
  {
    x: 4.2792792793,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.018018018,
    line4: 13.4684684685,
    line5: 674.8018017366,
    line6: 12.8511487938,
    line_animate: 71.5585585585,
  },
  {
    x: 4.2842842843,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.0780780781,
    line4: 13.5485485485,
    line5: 686.7337336673,
    line6: 12.9253839344,
    line_animate: 72.6796796796,
  },
  {
    x: 4.2892892893,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.1381381381,
    line4: 13.6286286286,
    line5: 698.6656655981,
    line6: 12.9997479438,
    line_animate: 73.8008008007,
  },
  {
    x: 4.2942942943,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.1981981982,
    line4: 13.7087087087,
    line5: 710.5975975288,
    line6: 13.0745593666,
    line_animate: 74.9219219219,
  },
  {
    x: 4.2992992993,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.2582582583,
    line4: 13.7887887888,
    line5: 722.5295294596,
    line6: 13.1496968943,
    line_animate: 76.043043043,
  },
  {
    x: 4.3043043043,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.3183183183,
    line4: 13.8688688689,
    line5: 734.4614613904,
    line6: 13.2249800798,
    line_animate: 77.1641641641,
  },
  {
    x: 4.3093093093,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.3783783784,
    line4: 13.9489489489,
    line5: 746.3933933211,
    line6: 13.3003819162,
    line_animate: 78.2852852852,
  },
  {
    x: 4.3143143143,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.4384384384,
    line4: 14.029029029,
    line5: 758.3253252519,
    line6: 13.3759388146,
    line_animate: 79.4064064063,
  },
  {
    x: 4.3193193193,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.4984984985,
    line4: 14.1091091091,
    line5: 770.2572571827,
    line6: 13.4516402227,
    line_animate: 80.5275275275,
  },
  {
    x: 4.3243243243,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.5585585586,
    line4: 14.1891891892,
    line5: 782.1891891134,
    line6: 13.5275647813,
    line_animate: 81.6486486486,
  },
  {
    x: 4.3293293293,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.6186186186,
    line4: 14.2692692693,
    line5: 794.1211210442,
    line6: 13.6036927767,
    line_animate: 82.7697697697,
  },
  {
    x: 4.3343343343,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.6786786787,
    line4: 14.3493493493,
    line5: 806.053052975,
    line6: 13.6802115781,
    line_animate: 83.8908908908,
  },
  {
    x: 4.3393393393,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.7387387387,
    line4: 14.4294294294,
    line5: 817.9849849057,
    line6: 13.7567501975,
    line_animate: 85.0120120119,
  },
  {
    x: 4.3443443443,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.7987987988,
    line4: 14.5095095095,
    line5: 829.9169168365,
    line6: 13.8336057675,
    line_animate: 86.1331331331,
  },
  {
    x: 4.3493493493,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.8588588589,
    line4: 14.5895895896,
    line5: 841.8488487672,
    line6: 13.9104788425,
    line_animate: 87.2542542542,
  },
  {
    x: 4.3543543544,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.9189189189,
    line4: 14.6696696697,
    line5: 853.780780698,
    line6: 13.987678036,
    line_animate: 88.3753753753,
  },
  {
    x: 4.3593593594,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 15.978978979,
    line4: 14.7497497497,
    line5: 865.7127126288,
    line6: 14.0652957613,
    line_animate: 89.4964964964,
  },
  {
    x: 4.3643643644,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.039039039,
    line4: 14.8298298298,
    line5: 877.6446445595,
    line6: 14.143162597,
    line_animate: 90.6176176175,
  },
  {
    x: 4.3693693694,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.0990990991,
    line4: 14.9099099099,
    line5: 889.5765764903,
    line6: 14.2210294327,
    line_animate: 91.7387387387,
  },
  {
    x: 4.3743743744,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.1591591592,
    line4: 14.98998999,
    line5: 901.5085084211,
    line6: 14.2990000779,
    line_animate: 92.8598598598,
  },
  {
    x: 4.3793793794,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.2192192192,
    line4: 15.0700700701,
    line5: 913.4404403518,
    line6: 14.3770924863,
    line_animate: 93.9809809809,
  },
  {
    x: 4.3843843844,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.2792792793,
    line4: 15.1501501502,
    line5: 925.3723722826,
    line6: 14.4552834751,
    line_animate: 95.102102102,
  },
  {
    x: 4.3893893894,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.3393393393,
    line4: 15.2302302302,
    line5: 937.3043042133,
    line6: 14.5334744638,
    line_animate: 96.2232232231,
  },
  {
    x: 4.3943943944,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.3993993994,
    line4: 15.3103103103,
    line5: 949.2362361441,
    line6: 14.6118442298,
    line_animate: 97.3443443443,
  },
  {
    x: 4.3993993994,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.4594594595,
    line4: 15.3903903904,
    line5: 961.1681680749,
    line6: 14.6905904961,
    line_animate: 98.4654654654,
  },
  {
    x: 4.4044044044,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.5195195195,
    line4: 15.4704704705,
    line5: 973.1001000056,
    line6: 14.7694092757,
    line_animate: 99.5865865865,
  },
  {
    x: 4.4094094094,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.5795795796,
    line4: 15.5505505506,
    line5: 985.0320319364,
    line6: 14.8484875261,
    line_animate: 100.7077077076,
  },
  {
    x: 4.4144144144,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.6396396396,
    line4: 15.6306306306,
    line5: 996.9639638672,
    line6: 14.9277054907,
    line_animate: 101.8288288287,
  },
  {
    x: 4.4194194194,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.6996996997,
    line4: 15.7107107107,
    line5: 1008.8958957979,
    line6: 15.0073805364,
    line_animate: 102.9499499499,
  },
  {
    x: 4.4244244244,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.7597597598,
    line4: 15.7907907908,
    line5: 1020.8278277287,
    line6: 15.0873557414,
    line_animate: 104.071071071,
  },
  {
    x: 4.4294294294,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.8198198198,
    line4: 15.8708708709,
    line5: 1032.7597596594,
    line6: 15.1674904746,
    line_animate: 105.1921921921,
  },
  {
    x: 4.4344344344,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.8798798799,
    line4: 15.950950951,
    line5: 1044.6916915902,
    line6: 15.2477923778,
    line_animate: 106.3133133132,
  },
  {
    x: 4.4394394394,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 16.9399399399,
    line4: 16.031031031,
    line5: 1056.623623521,
    line6: 15.3284249377,
    line_animate: 107.4344344343,
  },
  {
    x: 4.4444444444,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.0,
    line4: 16.1111111111,
    line5: 1068.5555554517,
    line6: 15.4092745287,
    line_animate: 108.5555555555,
  },
  {
    x: 4.4494494494,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.0600600601,
    line4: 16.1911911912,
    line5: 1080.4874873825,
    line6: 15.4901830486,
    line_animate: 109.6766766766,
  },
  {
    x: 4.4544544545,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.1201201201,
    line4: 16.2712712713,
    line5: 1092.4194193133,
    line6: 15.5713876071,
    line_animate: 110.7977977977,
  },
  {
    x: 4.4594594595,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.1801801802,
    line4: 16.3513513514,
    line5: 1104.351351244,
    line6: 15.6529455989,
    line_animate: 111.9189189188,
  },
  {
    x: 4.4644644645,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.2402402402,
    line4: 16.4314314314,
    line5: 1116.2832831748,
    line6: 15.7346993405,
    line_animate: 113.0400400399,
  },
  {
    x: 4.4694694695,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.3003003003,
    line4: 16.5115115115,
    line5: 1128.2152151055,
    line6: 15.8165051404,
    line_animate: 114.1611611611,
  },
  {
    x: 4.4744744745,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.3603603604,
    line4: 16.5915915916,
    line5: 1140.1471470363,
    line6: 15.8985910883,
    line_animate: 115.2822822822,
  },
  {
    x: 4.4794794795,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.4204204204,
    line4: 16.6716716717,
    line5: 1152.0790789671,
    line6: 15.9807941019,
    line_animate: 116.4034034033,
  },
  {
    x: 4.4844844845,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.4804804805,
    line4: 16.7517517518,
    line5: 1164.0110108978,
    line6: 16.0630921748,
    line_animate: 117.5245245244,
  },
  {
    x: 4.4894894895,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.5405405405,
    line4: 16.8318318318,
    line5: 1175.9429428286,
    line6: 16.1453902478,
    line_animate: 118.6456456455,
  },
  {
    x: 4.4944944945,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.6006006006,
    line4: 16.9119119119,
    line5: 1187.8748747594,
    line6: 16.2276883208,
    line_animate: 119.7667667667,
  },
  {
    x: 4.4994994995,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.6606606607,
    line4: 16.991991992,
    line5: 1199.8068066901,
    line6: 16.3099936917,
    line_animate: 120.8878878878,
  },
  {
    x: 4.5045045045,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.7207207207,
    line4: 17.0720720721,
    line5: 1190.4054052897,
    line6: 16.3926049851,
    line_animate: 120.135135135,
  },
  {
    x: 4.5095095095,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.7807807808,
    line4: 17.1521521522,
    line5: 1178.6336335191,
    line6: 16.4752885209,
    line_animate: 119.1741741741,
  },
  {
    x: 4.5145145145,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.8408408408,
    line4: 17.2322322322,
    line5: 1166.8618617485,
    line6: 16.5579720566,
    line_animate: 118.2132132131,
  },
  {
    x: 4.5195195195,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.9009009009,
    line4: 17.3123123123,
    line5: 1155.0900899778,
    line6: 16.6407488534,
    line_animate: 117.2522522522,
  },
  {
    x: 4.5245245245,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 17.960960961,
    line4: 17.3923923924,
    line5: 1143.3183182072,
    line6: 16.7236432716,
    line_animate: 116.2912912912,
  },
  {
    x: 4.5295295295,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.021021021,
    line4: 17.4724724725,
    line5: 1131.5465464366,
    line6: 16.8066151712,
    line_animate: 115.3303303302,
  },
  {
    x: 4.5345345345,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.0810810811,
    line4: 17.5525525526,
    line5: 1119.774774666,
    line6: 16.8897325711,
    line_animate: 114.3693693693,
  },
  {
    x: 4.5395395395,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.1411411411,
    line4: 17.6326326326,
    line5: 1108.0030028954,
    line6: 16.9730430959,
    line_animate: 113.4084084083,
  },
  {
    x: 4.5445445445,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.2012012012,
    line4: 17.7127127127,
    line5: 1096.2312311248,
    line6: 17.0564584356,
    line_animate: 112.4474474474,
  },
  {
    x: 4.5495495495,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.2612612613,
    line4: 17.7927927928,
    line5: 1084.4594593542,
    line6: 17.1400495311,
    line_animate: 111.4864864864,
  },
  {
    x: 4.5545545546,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.3213213213,
    line4: 17.8728728729,
    line5: 1072.6876875836,
    line6: 17.2238267436,
    line_animate: 110.5255255254,
  },
  {
    x: 4.5595595596,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.3813813814,
    line4: 17.952952953,
    line5: 1060.915915813,
    line6: 17.3076990599,
    line_animate: 109.5645645645,
  },
  {
    x: 4.5645645646,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.4414414414,
    line4: 18.033033033,
    line5: 1049.1441440424,
    line6: 17.3915713763,
    line_animate: 108.6036036035,
  },
  {
    x: 4.5695695696,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.5015015015,
    line4: 18.1131131131,
    line5: 1037.3723722718,
    line6: 17.4754436926,
    line_animate: 107.6426426426,
  },
  {
    x: 4.5745745746,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.5615615616,
    line4: 18.1931931932,
    line5: 1025.6006005012,
    line6: 17.5593160089,
    line_animate: 106.6816816816,
  },
  {
    x: 4.5795795796,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.6216216216,
    line4: 18.2732732733,
    line5: 1013.8288287306,
    line6: 17.6431883253,
    line_animate: 105.7207207206,
  },
  {
    x: 4.5845845846,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.6816816817,
    line4: 18.3533533534,
    line5: 1002.05705696,
    line6: 17.7273478243,
    line_animate: 104.7597597597,
  },
  {
    x: 4.5895895896,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.7417417417,
    line4: 18.4334334334,
    line5: 990.2852851894,
    line6: 17.811647867,
    line_animate: 103.7987987987,
  },
  {
    x: 4.5945945946,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.8018018018,
    line4: 18.5135135135,
    line5: 978.5135134188,
    line6: 17.8961285894,
    line_animate: 102.8378378378,
  },
  {
    x: 4.5995995996,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.8618618619,
    line4: 18.5935935936,
    line5: 966.7417416482,
    line6: 17.9807797755,
    line_animate: 101.8768768768,
  },
  {
    x: 4.6046046046,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.9219219219,
    line4: 18.6736736737,
    line5: 954.9699698776,
    line6: 18.0655347359,
    line_animate: 100.9159159158,
  },
  {
    x: 4.6096096096,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 18.981981982,
    line4: 18.7537537538,
    line5: 943.198198107,
    line6: 18.1505750319,
    line_animate: 99.9549549549,
  },
  {
    x: 4.6146146146,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.042042042,
    line4: 18.8338338338,
    line5: 931.4264263364,
    line6: 18.2358822551,
    line_animate: 98.9939939939,
  },
  {
    x: 4.6196196196,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.1021021021,
    line4: 18.9139139139,
    line5: 919.6546545658,
    line6: 18.3213930417,
    line_animate: 98.033033033,
  },
  {
    x: 4.6246246246,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.1621621622,
    line4: 18.993993994,
    line5: 907.8828827952,
    line6: 18.4070256798,
    line_animate: 97.072072072,
  },
  {
    x: 4.6296296296,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.2222222222,
    line4: 19.0740740741,
    line5: 896.1111110246,
    line6: 18.4927731023,
    line_animate: 96.111111111,
  },
  {
    x: 4.6346346346,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.2822822823,
    line4: 19.1541541542,
    line5: 884.339339254,
    line6: 18.5786383517,
    line_animate: 95.1501501501,
  },
  {
    x: 4.6396396396,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.3423423423,
    line4: 19.2342342342,
    line5: 872.5675674834,
    line6: 18.6646145536,
    line_animate: 94.1891891891,
  },
  {
    x: 4.6446446446,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.4024024024,
    line4: 19.3143143143,
    line5: 860.7957957128,
    line6: 18.7506911651,
    line_animate: 93.2282282282,
  },
  {
    x: 4.6496496496,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.4624624625,
    line4: 19.3943943944,
    line5: 849.0240239422,
    line6: 18.8369276049,
    line_animate: 92.2672672672,
  },
  {
    x: 4.6546546547,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.5225225225,
    line4: 19.4744744745,
    line5: 837.2522521716,
    line6: 18.9232443667,
    line_animate: 91.3063063062,
  },
  {
    x: 4.6596596597,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.5825825826,
    line4: 19.5545545546,
    line5: 825.480480401,
    line6: 19.0095890191,
    line_animate: 90.3453453453,
  },
  {
    x: 4.6646646647,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.6426426426,
    line4: 19.6346346346,
    line5: 813.7087086304,
    line6: 19.0960341735,
    line_animate: 89.3843843843,
  },
  {
    x: 4.6696696697,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.7027027027,
    line4: 19.7147147147,
    line5: 801.9369368598,
    line6: 19.1825668972,
    line_animate: 88.4234234234,
  },
  {
    x: 4.6746746747,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.7627627628,
    line4: 19.7947947948,
    line5: 790.1651650892,
    line6: 19.2691661361,
    line_animate: 87.4624624624,
  },
  {
    x: 4.6796796797,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.8228228228,
    line4: 19.8748748749,
    line5: 778.3933933186,
    line6: 19.3557880716,
    line_animate: 86.5015015014,
  },
  {
    x: 4.6846846847,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.8828828829,
    line4: 19.954954955,
    line5: 766.621621548,
    line6: 19.4426232338,
    line_animate: 85.5405405405,
  },
  {
    x: 4.6896896897,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 19.9429429429,
    line4: 20.035035035,
    line5: 754.8498497774,
    line6: 19.5295441903,
    line_animate: 84.5795795795,
  },
  {
    x: 4.6946946947,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.003003003,
    line4: 20.1151151151,
    line5: 743.0780780068,
    line6: 19.6165835504,
    line_animate: 83.6186186186,
  },
  {
    x: 4.6996996997,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.0630630631,
    line4: 20.1951951952,
    line5: 731.3063062362,
    line6: 19.7036660172,
    line_animate: 82.6576576576,
  },
  {
    x: 4.7047047047,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.1231231231,
    line4: 20.2752752753,
    line5: 719.5345344656,
    line6: 19.790906373,
    line_animate: 81.6966966966,
  },
  {
    x: 4.7097097097,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.1831831832,
    line4: 20.3553553554,
    line5: 707.762762695,
    line6: 19.8782078376,
    line_animate: 80.7357357357,
  },
  {
    x: 4.7147147147,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.2432432432,
    line4: 20.4354354354,
    line5: 695.9909909243,
    line6: 19.9655093021,
    line_animate: 79.7747747747,
  },
  {
    x: 4.7197197197,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.3033033033,
    line4: 20.5155155155,
    line5: 684.2192191537,
    line6: 20.0528107667,
    line_animate: 78.8138138138,
  },
  {
    x: 4.7247247247,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.3633633634,
    line4: 20.5955955956,
    line5: 672.4474473831,
    line6: 20.1401321819,
    line_animate: 77.8528528528,
  },
  {
    x: 4.7297297297,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.4234234234,
    line4: 20.6756756757,
    line5: 660.6756756125,
    line6: 20.2275027207,
    line_animate: 76.8918918918,
  },
  {
    x: 4.7347347347,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.4834834835,
    line4: 20.7557557558,
    line5: 648.9039038419,
    line6: 20.3149243769,
    line_animate: 75.9309309309,
  },
  {
    x: 4.7397397397,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.5435435435,
    line4: 20.8358358358,
    line5: 637.1321320713,
    line6: 20.4024010377,
    line_animate: 74.9699699699,
  },
  {
    x: 4.7447447447,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.6036036036,
    line4: 20.9159159159,
    line5: 625.3603603007,
    line6: 20.4899486386,
    line_animate: 74.009009009,
  },
  {
    x: 4.7497497497,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.6636636637,
    line4: 20.995995996,
    line5: 613.5885885301,
    line6: 20.5775159769,
    line_animate: 73.048048048,
  },
  {
    x: 4.7547547548,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.7237237237,
    line4: 21.0760760761,
    line5: 601.8168167595,
    line6: 20.6650833153,
    line_animate: 72.087087087,
  },
  {
    x: 4.7597597598,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.7837837838,
    line4: 21.1561561562,
    line5: 590.0450449889,
    line6: 20.7526768031,
    line_animate: 71.1261261261,
  },
  {
    x: 4.7647647648,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.8438438438,
    line4: 21.2362362362,
    line5: 578.2732732183,
    line6: 20.8404227826,
    line_animate: 70.1651651651,
  },
  {
    x: 4.7697697698,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.9039039039,
    line4: 21.3163163163,
    line5: 566.5015014477,
    line6: 20.9281910952,
    line_animate: 69.2042042042,
  },
  {
    x: 4.7747747748,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 20.963963964,
    line4: 21.3963963964,
    line5: 554.7297296771,
    line6: 21.0160062193,
    line_animate: 68.2432432432,
  },
  {
    x: 4.7797797798,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.024024024,
    line4: 21.4764764765,
    line5: 542.9579579065,
    line6: 21.1039050691,
    line_animate: 67.2822822822,
  },
  {
    x: 4.7847847848,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.0840840841,
    line4: 21.5565565566,
    line5: 531.1861861359,
    line6: 21.1918188776,
    line_animate: 66.3213213213,
  },
  {
    x: 4.7897897898,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.1441441441,
    line4: 21.6366366366,
    line5: 519.4144143653,
    line6: 21.2797769013,
    line_animate: 65.3603603603,
  },
  {
    x: 4.7947947948,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.2042042042,
    line4: 21.7167167167,
    line5: 507.6426425947,
    line6: 21.3677431825,
    line_animate: 64.3993993994,
  },
  {
    x: 4.7997997998,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.2642642643,
    line4: 21.7967967968,
    line5: 495.8708708241,
    line6: 21.455728686,
    line_animate: 63.4384384384,
  },
  {
    x: 4.8048048048,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.3243243243,
    line4: 21.8768768769,
    line5: 484.0990990535,
    line6: 21.5437485808,
    line_animate: 62.4774774774,
  },
  {
    x: 4.8098098098,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.3843843844,
    line4: 21.956956957,
    line5: 472.3273272829,
    line6: 21.6318115353,
    line_animate: 61.5165165165,
  },
  {
    x: 4.8148148148,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.4444444444,
    line4: 22.037037037,
    line5: 460.5555555123,
    line6: 21.7198744898,
    line_animate: 60.5555555555,
  },
  {
    x: 4.8198198198,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.5045045045,
    line4: 22.1171171171,
    line5: 448.7837837417,
    line6: 21.8080135777,
    line_animate: 59.5945945946,
  },
  {
    x: 4.8248248248,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.5645645646,
    line4: 22.1971971972,
    line5: 437.0120119711,
    line6: 21.8961655054,
    line_animate: 58.6336336336,
  },
  {
    x: 4.8298298298,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.6246246246,
    line4: 22.2772772773,
    line5: 425.2402402005,
    line6: 21.9843189226,
    line_animate: 57.6726726726,
  },
  {
    x: 4.8348348348,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.6846846847,
    line4: 22.3573573574,
    line5: 413.4684684299,
    line6: 22.0725366221,
    line_animate: 56.7117117117,
  },
  {
    x: 4.8398398398,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.7447447447,
    line4: 22.4374374374,
    line5: 401.6966966593,
    line6: 22.1608933276,
    line_animate: 55.7507507507,
  },
  {
    x: 4.8448448448,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.8048048048,
    line4: 22.5175175175,
    line5: 389.9249248887,
    line6: 22.2493000591,
    line_animate: 54.7897897898,
  },
  {
    x: 4.8498498498,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.8648648649,
    line4: 22.5975975976,
    line5: 378.1531531181,
    line6: 22.3377549294,
    line_animate: 53.8288288288,
  },
  {
    x: 4.8548548549,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.9249249249,
    line4: 22.6776776777,
    line5: 366.3813813475,
    line6: 22.4262177118,
    line_animate: 52.8678678678,
  },
  {
    x: 4.8598598599,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 21.984984985,
    line4: 22.7577577578,
    line5: 354.6096095769,
    line6: 22.5146804941,
    line_animate: 51.9069069069,
  },
  {
    x: 4.8648648649,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.045045045,
    line4: 22.8378378378,
    line5: 342.8378378063,
    line6: 22.6031432764,
    line_animate: 50.9459459459,
  },
  {
    x: 4.8698698699,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.1051051051,
    line4: 22.9179179179,
    line5: 331.0660660357,
    line6: 22.6916207813,
    line_animate: 49.984984985,
  },
  {
    x: 4.8748748749,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.1651651652,
    line4: 22.997997998,
    line5: 319.2942942651,
    line6: 22.7801142114,
    line_animate: 49.024024024,
  },
  {
    x: 4.8798798799,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.2252252252,
    line4: 23.0780780781,
    line5: 307.5225224945,
    line6: 22.8686076415,
    line_animate: 48.063063063,
  },
  {
    x: 4.8848848849,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.2852852853,
    line4: 23.1581581582,
    line5: 295.7507507239,
    line6: 22.9571078643,
    line_animate: 47.1021021021,
  },
  {
    x: 4.8898898899,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.3453453453,
    line4: 23.2382382382,
    line5: 283.9789789533,
    line6: 23.045660926,
    line_animate: 46.1411411411,
  },
  {
    x: 4.8948948949,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.4054054054,
    line4: 23.3183183183,
    line5: 272.2072071827,
    line6: 23.1342317714,
    line_animate: 45.1801801802,
  },
  {
    x: 4.8998998999,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.4654654655,
    line4: 23.3983983984,
    line5: 260.4354354121,
    line6: 23.2228773813,
    line_animate: 44.2192192192,
  },
  {
    x: 4.9049049049,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.5255255255,
    line4: 23.4784784785,
    line5: 248.6636636415,
    line6: 23.3115625504,
    line_animate: 43.2582582582,
  },
  {
    x: 4.9099099099,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.5855855856,
    line4: 23.5585585586,
    line5: 236.8918918708,
    line6: 23.4002617734,
    line_animate: 42.2972972973,
  },
  {
    x: 4.9149149149,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.6456456456,
    line4: 23.6386386386,
    line5: 225.1201201002,
    line6: 23.48902084,
    line_animate: 41.3363363363,
  },
  {
    x: 4.9199199199,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.7057057057,
    line4: 23.7187187187,
    line5: 213.3483483296,
    line6: 23.5778158408,
    line_animate: 40.3753753754,
  },
  {
    x: 4.9249249249,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.7657657658,
    line4: 23.7987987988,
    line5: 201.576576559,
    line6: 23.6666467019,
    line_animate: 39.4144144144,
  },
  {
    x: 4.9299299299,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.8258258258,
    line4: 23.8788788789,
    line5: 189.8048047884,
    line6: 23.7554788639,
    line_animate: 38.4534534534,
  },
  {
    x: 4.9349349349,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.8858858859,
    line4: 23.958958959,
    line5: 178.0330330178,
    line6: 23.8443143046,
    line_animate: 37.4924924925,
  },
  {
    x: 4.9399399399,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 22.9459459459,
    line4: 24.039039039,
    line5: 166.2612612472,
    line6: 23.9331668793,
    line_animate: 36.5315315315,
  },
  {
    x: 4.9449449449,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.006006006,
    line4: 24.1191191191,
    line5: 154.4894894766,
    line6: 24.0220241909,
    line_animate: 35.5705705706,
  },
  {
    x: 4.9499499499,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.0660660661,
    line4: 24.1991991992,
    line5: 142.717717706,
    line6: 24.1109003957,
    line_animate: 34.6096096096,
  },
  {
    x: 4.954954955,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.1261261261,
    line4: 24.2792792793,
    line5: 130.9459459354,
    line6: 24.1997894412,
    line_animate: 33.6486486486,
  },
  {
    x: 4.95995996,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.1861861862,
    line4: 24.3593593594,
    line5: 119.1741741648,
    line6: 24.2886958184,
    line_animate: 32.6876876877,
  },
  {
    x: 4.964964965,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.2462462462,
    line4: 24.4394394394,
    line5: 107.4024023942,
    line6: 24.3776039265,
    line_animate: 31.7267267267,
  },
  {
    x: 4.96996997,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.3063063063,
    line4: 24.5195195195,
    line5: 95.6306306236,
    line6: 24.4665161604,
    line_animate: 30.7657657658,
  },
  {
    x: 4.974974975,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.3663663664,
    line4: 24.5995995996,
    line5: 83.858858853,
    line6: 24.5554322476,
    line_animate: 29.8048048048,
  },
  {
    x: 4.97997998,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.4264264264,
    line4: 24.6796796797,
    line5: 72.0870870824,
    line6: 24.6443483348,
    line_animate: 28.8438438438,
  },
  {
    x: 4.984984985,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.4864864865,
    line4: 24.7597597598,
    line5: 60.3153153118,
    line6: 24.7332644858,
    line_animate: 27.8828828829,
  },
  {
    x: 4.98998999,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.5465465465,
    line4: 24.8398398398,
    line5: 48.5435435412,
    line6: 24.8221805122,
    line_animate: 26.9219219219,
  },
  {
    x: 4.994994995,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.6066066066,
    line4: 24.9199199199,
    line5: 36.7717717706,
    line6: 24.9110921917,
    line_animate: 25.960960961,
  },
  {
    x: 5.0,
    line1: 61.6666666667,
    line2: 11.6666666667,
    line3: 23.6666666667,
    line4: 25.0,
    line5: 25.0,
    line6: 25.0,
    line_animate: 25.0,
  },
];
